 function GlobalAccountConfigCtrl($scope, $timeout, $state, $controller,  $filter, $sce, IconsService, $rootScope, $element, GeneralUtilsService, LocationService, FieldsService, ValidationService, FailoverConfigurationService, UserContextService, MaintenanceWindowService, SlaSettingService) {
	$controller('SecurityCtrl', { $scope: $scope, $timeout: $timeout, $state: $state, GeneralUtilsService: GeneralUtilsService});
	$controller('ConfigController', { $scope: $scope, $timeout: $timeout });

   	$scope.showPassword = function(){
        $("#passwordfield").attr('type','text');
    };
    $scope.hidePassword = function(){
        $("#passwordfield").attr('type','password');
    };
	var firstLoad = true;
	const DEFAULT_PAGE_SIZE = 5;

	const FieldTypes = FieldsService.getFieldTypes();
	const fieldsForType = {
		trustedEntities: {
			destinations: {
				name: 'destinations',
				id: 'destinations',

				types: [
		{
			name: 'Applications',
			field: FieldTypes.allApps,
		},
		{
			name: 'Custom Applications',
			field: FieldTypes.customApplications,
		},
		{

			name: 'Categories',
			field: FieldTypes.categories,
		},
		{
			name: 'Custom Categories',
			field: FieldTypes.customCategories,
		},
		{
			name: 'Fully Qualified Domain Name',
			field: FieldTypes.FQDN,
		},
		{
			name: 'Top Level Domain',
			field: FieldTypes.TLD,
		},
		{
			name: 'Custom Service (By IP)',
			field: FieldTypes.customService,
		},
		{
			name: 'Services',
			field: FieldTypes.services
		},
		{
			name: 'Ports',
			field: FieldTypes.ports
		}]
			},
		},
		tls: {
			destinations:{
				name: 'To',
				id: 'destinations',
				types: [
					{
						name: 'All',
						field: FieldTypes.all,
					},
					{
						name: 'Applications',
						field: FieldTypes.allApps,
					},
					{
						name: 'Custom Applications',
						field: FieldTypes.customApplications,
					},
					{

						name: 'Categories',
						field: FieldTypes.categories,
					},
					{
						name: 'Custom Categories',
						field: FieldTypes.customCategories,
					},
					{
						name: 'Fully Qualified Domain Name',
						field: FieldTypes.FQDN,
					},
					{
						name: 'Top Level Domain',
						field: FieldTypes.TLD,
					},
					{
						name: 'Custom Service (By IP)',
						field: FieldTypes.customService,
					},
					{
						name: 'Services',
						field: FieldTypes.services
					},
					{
						name: 'Ports',
						field: FieldTypes.ports
					}]
			},
			entities: {
				name: 'To',
				id: 'entities',

				types: [
					{
						name: 'All',
						field: FieldTypes.all,
					},
					{
						name: 'Site',
						field: FieldTypes.sites
					}, {
						name: 'VPN User',
						field: FieldTypes.accesslogins
					}, {
						name: 'Groups',
						field: FieldTypes.groups
					}, {
						name: 'Hosts',
						field: FieldTypes.subnets
					}, {
						name: 'Networks',
						field: FieldTypes.ipRanges
					}, {
						name: 'DS User',
						field: FieldTypes.dsUser
					}, {
						name: 'Floating Ranges',
						field: FieldTypes.floatingIps
					}, {
						name: 'IP Address',
						field: FieldTypes.ips
					}]
			},
			entitiesNotToInspect: {
				name: 'Except Of',
				id: 'entitiesNotToInspect',
				types: [
					{
						name: 'All',
						field: FieldTypes.all,
					},
					{
						name: 'Site',
						field: FieldTypes.sites
					}, {
						name: 'VPN User',
						field: FieldTypes.accesslogins
					}, {
						name: 'Groups',
						field: FieldTypes.groups
					}, {
						name: 'Hosts',
						field: FieldTypes.subnets
					}, {
						name: 'Networks',
						field: FieldTypes.ipRanges
					}, {
						name: 'DS User',
						field: FieldTypes.dsUser
					}, {
						name: 'Floating IP',
						field: FieldTypes.floatingIps
					}]
			},
		},
	};

	$scope.proxyFileConfigProperties={};

    $scope.splitTunnelDirection = {name:'EXCLUDE'};
	$scope.ipAllocationProperties = {wasChanged : false};
	$scope.allowAnyDest = null;
	$scope.loaders = {groups:true};
	$scope.oktaConfiguration = {};
	$scope.scimProvisioning = {};
	$scope.provider=null;

    $scope.mydomain = null;

	$scope.icons = IconsService.getIcons();
	$scope.showEgress = 'service';
	$scope.showDest = 'service';
	$scope.newIPApplication = { ips: '' };
	$scope.newMailDef = { freeText: '' };
	$scope.remotePortForwarding = {};
	$scope.timeConstraints = { type: 'always', timeDef: { isA: 'Time', days: [], times: [], reoccurring: true } };
	$scope.datamodifiedMailingList = false;
	$scope.datamodifiedSyslog = false;
	$scope.datamodifiedTlsInspection = false;
	$scope.groupsModified = false;
	$scope.datamodifiedSync = false;
	$scope.dnsdatamodified = false;
	$scope.dnssettingsdatamodified = false;
	$scope.progressReset = false;
	$scope.viewProgress = true;
	$scope.somethingChanged = false;
	$scope.showItem = 'admins';
	$scope.showEditPW = false;
	$scope.showOktaEditPW = false;
	$scope.maintenancePlanLoaded = false;
 	$scope.usingRpfBlockList = false;

	class ConfigurationCategory {
		name;
		id;
		fields; // fields list as json array of strings
		save; // (optional) save method instead of general one
		hasChanges; // method for checking if there were changes
		preSave; // (optional) method run before saving
		requireTag; // (optional) string tag name required to view category
		hideOnTag; // (optional) string tag name required to hide view category
		validate; // (optional) validation method that breaks the save if fails
		onSaveSuccessCallback; // (optional) callback to call on success save

		constructor(options = {}, extendWithCategory = {}) {
			angular.extend(this, options, extendWithCategory);
		}
	}
	let categories = [];


	if (isSystemLogin) {
		$scope.isSystemLogin = true;
	}

    $scope.splitTunnelEnforce = [
        {value:"ACCOUNT_LEVEL", key:"Cato Management Application"},
        {value:"USER_DEFINED", key:"End-user defined"}
    ];

    $scope.splitTunnelConfig = {
        id: "splitTunnelConfiguration",
        isDup: function(name) {
            return name && this.items.filter(function(element){
                                 return element.id == name;
                             }).length > 1;
        },
        dataURL: function () {
            return '/getAccountSplitTunnel?accountId=' + $state.params.accountId;
        },
        noSearch: true,
        fields: [
               { label: 'Name', path: 'id', template: "<span><input type='text' class='form-control' ng-model='item.id' ><div  ng-show='item.id && tableConfig.isDup(item.id)' class='help-block with-errors'><ul class='list-unstyled'><li><pre>Range name must be unique.</pre></li></ul></div></input></span>" },
               { label: 'IP', path: 'ip', template: "<span><input type='text' class='form-control' ng-model='item.ip' /></span>" },
               { label: 'Mask', path: 'mask', template: "<span><input type='text' class='form-control' ng-model='item.mask' /></span>" }
        ],
        selectedItems: [],
        specialActions : [
            {'icon':'add','tooltip':'Add','func' :
                function(selectedItems,config) {
                if (!$scope.splitTunnelConfig.items) { $scope.splitTunnelConfig.items = []; }
                    $scope.splitTunnelConfig.items.push({"id":"","ip":"",mask:''});
                    $scope.updateRightScroll();
                }
            },
            {
                func: function (selectedItems) {
                    selectedItems.forEach(function (item) {
                        for (var i = 0; i < $scope.splitTunnelConfig.items.length; i++) {
                            var list = $scope.splitTunnelConfig.items[i];
                            if (list.id == item.id) {
                                $scope.splitTunnelConfig.items.splice(i, 1);
                                break;
                            }
                        }
                    });
                },
                icon: 'delete',
                tooltip: 'Delete',
            },],
        parseData: function (items) {
            $scope.splitTunnelDirection.name = 'EXCLUDE';
            if (items.length > 0 && items[0].config) {

                $scope.origSplitTunnelId = items[0].id;
                //  all ips should have the same direction...
                if (items[0].config.length > 0) {
                    $scope.splitTunnelDirection.name = items[0].config[0].action;
                }
                $scope.splitTunnelDirectionOrig = angular.copy($scope.splitTunnelDirection);
                $scope.origSplitTunnel = angular.copy(items[0].config);

                return items[0].config;
            }
            $scope.origSplitTunnel = [];
            $scope.splitTunnelDirectionOrig = angular.copy($scope.splitTunnelDirection);
            return [];
        },
        actions: [],
    };

	$scope.sites = [];

	$scope.dsUsersConfig = {
		titleSearch: true,
		accountId: $state.params.accountId,
		dataURL: function () {
			return '/getAllDsUsers?accountId=' + $state.params.accountId;
		},
		fields: [{ label: 'Name', path: 'Login Name', template: '<span>{{item.loginName}}</span>' },
                    { label: 'Subnet', path: 'Full Name', template: '<span>{{item.fullName}}</span>' },
		],
		processData: function (items) {
		},
		type: 'DIRECTORYSERVICEUSER',
		actions: [],
		selectedItems: [],
		pageSize: DEFAULT_PAGE_SIZE,

	};


	function load() {
		loadAccount();

		categories = [
			new ConfigurationCategory({
				name: 'DHCP',
				id: 'DHCP',
				fields: "['dhcpConfig']",
				save: (fields)=> {
					sendAccountSave(fields);
				},
				hasChanges: ()=> {
					return $scope.hasDhcpRelayChanges() || $scope.hasChanges.dhcpSettings || $scope.hasChanges.dhcpRelayGroups;
				},
			}),
			new ConfigurationCategory({
				name: 'Directory Services', id: 'DirectoryServices', save: $scope.saveLDAP,
				hasChanges: ()=> {
					return $scope.hasChanges.directoryServices
				}
			}),
			new ConfigurationCategory({
				name: 'DNS', id: 'DNS', fields: "['dnsForwarding','dnsSettings','reverseDnsLookup']",
				preSave: ()=> {
					if ($scope.account.reverseDnsLookup[0] && $scope.reverseDnsConfig.items) {
						$scope.account.reverseDnsLookup[0] = {
							id: $scope.account.reverseDnsLookup[0].id,
							name: 'ReverseDnsLookup',
							ips: $scope.reverseDnsConfig.items.map(function (item) {
								return item.ip;
							})
						};
					}
					else if ($scope.reverseDnsConfig.items) {
						if ($scope.reverseDnsConfig.items) {
							if (!$scope.account.reverseDnsLookup) {
								$scope.account.reverseDnsLookup = [];
							}
						}
						$scope.account.reverseDnsLookup.push({
							name: 'ReverseDnsLookup',
							ips: $scope.reverseDnsConfig.items.map(function (item) {
								return item.ip;
							}),
						});
					}
				},
				hasChanges: ()=> {
					return $scope.hasDnsSettingsChanges() || $scope.hasDnsForwardingChanges() || !angular.equals($scope.origReverseDns, $scope.reverseDnsConfig.items);
				}
			}),
			new ConfigurationCategory({
				name: 'Floating Ranges', id: 'FloatingIps', fields: "['floatingIps']", hasChanges: ()=> {
					return $scope.hasChanges.floatingIps;
				}
			}),
			new ConfigurationCategory({
				name: 'IP Allocation',
				id: 'IPAllocation',
				save: ()=> {
					// if the was change flag is on we should save egress
					if ($scope.ipAllocationProperties.wasChanged) {
						$scope.ipAllocationProperties.saveEgress(function () {
							/*
							 * saving the egress meaning that the global account configuration is on the
							 * define egress screen meaning the saving will be done by the directive itself thus we remove the properties
							 * regarding the egress enabled
							 */
							$scope.loading = false;
							loadAccount();
						}, function () {
							$scope.loading = false;
						});
					}
				},
				hasChanges: ()=> {
					return $scope.ipAllocationProperties.wasChanged;
				}
			}),
			new ConfigurationCategory({
				name: 'Publish Additional IPs',
				id: 'PublishAdditionalIPs',
				requireTag: 'ISP_CONFIG_IPS',
				fields: "['crossConnectNatIps']",
				hasChanges: ()=> {
					return !angular.equals($scope.account.crossConnectNatIps, $scope.orig.crossConnectNatIps);
				}
			}),
			new ConfigurationCategory({
				name: 'Remote Port Forwarding',
				id: 'RemotePortForwarding',
				fields: "['remotePortForwardingRules','remotePortForwardingEnabled']",
				preSave: updatePortForwardingRules,
				hasChanges: ()=> {
					return $scope.account.remotePortForwardingEnabled != $scope.orig.remotePortForwardingEnabled || !angular.equals($scope.portForwardingMetadataOrig, $scope.remotePortForwarding.portForwardingMetadata);
				},
				save: remotePortForwardingSave
			}),
			new ConfigurationCategory({
				name: 'Last-Mile Monitoring',
				id: 'lastMileConnectivity',
				fields: "['lastMileMonitRule']",
				hasChanges: ()=> {
					return $scope.hasChanges.lastMileMonitoring
				}
			}),
			new ConfigurationCategory({
				name: 'Mailing Lists',
				id: 'MailingLists',
				save: $scope.saveMailingLists,
				hasChanges: ()=> {
					return !angular.equals($scope.origMailingDefinition, $scope.mailingListConfig.items)
				}
			}),
			new ConfigurationCategory({
				name: 'TLS Inspection',
				id: 'TLSInspection',
				fields: () => {
					return "['tlsInspectionConfig']";
				},
				preSave: updateTlsInspection,
				hasChanges: ()=> {
					if ($scope.account) {
						let tlsInspectionEnableChanged = !angular.equals($scope.account.tlsInspectionConfig.tlsInspectionEnabled, $scope.tlsInspectionOrig.tlsInspectionEnabled);
						let tlsInspectionRulesChanged = $scope.tlsInspectionRulesTableConfig.items && (!angular.equals($scope.tlsInspectionRulesOrig, $scope.tlsInspectionRulesTableConfig.items));
						let tlsInspectionActionsChanged = !angular.equals($scope.tlsInspectionActionsOrig, $scope.tlsInspectionActionConfig.items);
						return tlsInspectionRulesChanged || tlsInspectionEnableChanged || tlsInspectionActionsChanged;
					}
				}
			}),
			new ConfigurationCategory({
				name: 'Logs Exporter',
				id: 'LogsExporter',
				save: $scope.saveSyslog,
				hasChanges: $scope.hasSyslogChanges
			}),
			new ConfigurationCategory({
                name: 'MAC Address Authentication',
                id: 'MACAddressAuthentication',
                fields: "['macAddressAuthentication']",
                hasChanges: ()=> {
                    return $scope.hasChanges.macAddressAuthentication;
                }
            }),
			new ConfigurationCategory({
				name: 'Maintenance', id: 'Maintenance',
				fields: "['maintenanceTimeSlot']",
				hideOnTag: 'SR_MANAGED_MODE',
				hasChanges: ()=> {
					return !$scope.account.maintenanceTimeSlot ||
						($scope.account.maintenanceTimeSlot.day !== $scope.orig.maintenanceTimeSlot.day || $scope.account.maintenanceTimeSlot.hour !== $scope.orig.maintenanceTimeSlot.hour);
				},
				save: (fields)=> {
					sendAccountSave(fields);
				},
			}),
            new ConfigurationCategory({
                name: 'Socket Maintenance', id: 'SocketMaintenance',
                fields: "['maintenancePlan', 'sites']",
                requireTag: 'SR_MANAGED_MODE',
                save: (fields)=> {
					sendAccountSave(fields);
                },
                hasChanges: () => { return $scope.hasChanges.maintenancePlan},
                onSaveSuccessCallback: () => {$scope.hasChanges.maintenancePlan = false, $scope.maintenancePlanLoaded = false}
            }),
			new ConfigurationCategory({
				name: 'VPN Settings', id: 'VPN',
				fields: () => {
					if(isAlwaysOnSave()) {
						return "['trustedEntities','vpnRange','alwaysOnConfiguration', 'domains', 'deviceAuthenticationConfiguration']";
					} else {
						return "['vpnRange','proxyConfigurationFile','noVpnConfigurationFile','contactSupportPolicy'," +
							"'vpnAuthMethod', 'ssoCookieSettings','mfaConfiguration','ssoConfiguration','scimProvisioning','splitTunnelConfiguration'," +
							"'enableAccountSplitTunnel','splitTunnelEnforcement','domains','externalSystemConfiguration', 'controlUpgradePolicy', 'accessSettings'," +
							"'registrationCodeConfiguration', 'userProvisioningMethod', 'invitationEmailConfiguration', " +
							"'deviceAuthenticationConfiguration', 'certificates',vpnClientPolicy,'alwaysOnConfiguration']";
					}
				},
				preSave: () => {
					updateSplitTunnel();

					if($scope.externalSystem.ssoConfigurationEnabled && ($scope.provider === 'Okta' || $scope.provider === 'Onelogin'|| $scope.provider === 'Google')){
									if(!$scope.externalSystem.ssoConfiguration){
													$scope.externalSystem.ssoConfiguration = {};
									}
									$scope.externalSystem.ssoConfiguration.oktaConfiguration = $scope.oktaConfiguration;
					}

					if($scope.hasChanges.scimProvisioning){
									$scope.externalSystem.scimProvisioning[0] = $scope.scimProvisioning;
					}

					$scope.account.externalSystemConfiguration = $scope.externalSystem;

					if(isAlwaysOnSave()) {
						$scope.alwaysOnConfigProperties.setAlwaysOnConfig($scope.account);
					}
				},
				validate: ()=> {
					if (!validateVpnRange($scope.account.vpnRange)) {
						$scope.$root.errors['account.vpnRange'] = 'Only IP addresses with a CIDR range between /16 and /24 are valid for this setting.';
						return false;
					}

					if ($scope.account.certificates.some(item => item.isNewItem)) {
						$scope.$root.showNotification("error", "A certificate is missing the certificate file. Please upload the file and save the settings.", "Certificate", true, false);
						return false;
					}

					return true;
				},
				hasChanges: ()=> {
					return $scope.hasVpnChanges() || $scope.alwaysOnConfigProperties.wasChanged;
				}
			}),
            new ConfigurationCategory({
                name: 'Link Failover Settings',
                id: 'wanFailover',
                fields: "['failoverConfiguration']",
				hasChanges: () => {return $scope.hasChanges.failoverConfiguration;},
				requireTag: 'QOS_ALERTS',
				onSaveSuccessCallback: () => {$scope.hasChanges.failoverConfiguration = false;}
            }),
			new ConfigurationCategory({
				name: 'Connection SLA',
				id: 'slaSetting',
				fields: "['slaSetting']",
				hasChanges: () => {return $scope.hasChanges.slaSetting;},
				onSaveSuccessCallback: () => {$scope.hasChanges.slaSetting = false;}
			}),
			new ConfigurationCategory({
				name: 'Advanced Configuration',
				id: 'GeneralProperties',
				fields: "['generalProperties']",
				hasChanges: $scope.hasGeneralPropertiesChanges
			}),
		];

		$scope.trustedDestinationsCategory = categories.filter((cat)=> { return cat.id === 'TrustedDestinations'})[0];
		$scope.datamodified = new Date().getTime();
	}

	 function loadAccount() {
		store.fetch({
			path: 'getAccountSettings',
			queryParams: { accountId: $state.params.accountId, type: 'account'},
			success: function (data) {
				setAccount(data);
			},
		});
		loadExternalSystems();
		loadProviderFromAuthMethod();
	};

	$scope.actionsConfig = {
		selectedAction: null,
	};

	 $scope.actionsTlsInspectionConfig = {
		 selectedAction: null,
	 };

	$scope.changedToRegCodeUnsaved = function() {
	    return $scope.orig.userProvisioningMethod !== 'REG_CODE' && $scope.account.userProvisioningMethod === 'REG_CODE'
			|| $scope.orig.registrationCodeConfiguration.sendEmails !== $scope.account.registrationCodeConfiguration.sendEmails;
	};

	$scope.showConfigPageTitle = () => $scope.currentCategory && $scope.currentCategory.name === "Socket Maintenance";

	 let tlsTableHeader = [
		 { 'label': '', 'path': 'priority', noSort: true },
		 { 'label': 'Name', 'path': 'description', noSort: true },
		 { 'label': 'From', 'path': '', noSort: true },
		 { 'label': 'What', 'path': '', noSort: true },
		 { 'label': 'Action', 'path': '', noSort: true },
		 { 'label': 'Enable', 'path': '', noSort: true },
		 { 'label': '', 'path': '', noSort: true }
	 ];

	 $scope.tlsActions = [ // default for new tls config
	 	{ 'name':'Untrusted Server Certificates', 'action':'Prompt'}
	];

	 $scope.tlsRuleActionOptions = ['ALLOW', 'BLOCK', 'PROMPT'];

	 $scope.tlsRuleActionData = {
		 ALLOW: { name: 'Allow', icon: 'allow', class: 'action-allow' },
		 BLOCK: { name: 'Block', icon: 'block', class: 'action-block' },
		 PROMPT: { name: 'Prompt', icon: 'prompt', class: 'action-alert' },
	 }

	 $scope.tlsFields = fieldsForType.tls;

	 let indexesChangedOrder = [];

	 $scope.tlsInspectionRulesTableConfig = {
	 	clientSidePaging: true,
		hasChanges: $scope.$root.hasChanges,
		dataURL: function () {
			return null;
		},
		titleSearch: true,
		alternativeHead: tlsTableHeader,
		searchField: 'description',
		icons: IconsService.getIcons('policy'),
		clientSideSearch: true,
		noDataMessage: ' ',
		type: 'TlsInspectionRule',
		changeAction: function (item) {
			var itemName = $filter('removeSpecialChars')(item.name);
			$scope.$root.$emit('$openPopup', 'tlsInspectionRuleActions', 'action_' + itemName);
			$scope.actionsTlsInspectionConfig.rule = item;
		},
		ruleActions: ['Inspect', 'Bypass'],
		actionData: {
			Inspect: { name: 'Inspect', icon: 'inspect', class: 'action-inspect' },
			Bypass: { name: 'Bypass', icon: 'bypass', class: 'action-bypass' }
		},
		specialActions: [
			{
				icon: 'simple-plus',
				text: 'ADD RULE',
				tooltip: 'Add',
				id: 'add-tls-rule',
				innerActions: [
					{
						icon: 'top',
						name: 'Top',
						func: function () {
							addRule($scope.tlsInspectionRulesTableConfig, 0);
							const targetElId = 'inner-action-add-tls-rule';
							$scope.$root.toggleDropDown(targetElId);
						},
					},
					{
						icon: 'bottom',
						name: 'Bottom',
						func: function () {
							addRule($scope.tlsInspectionRulesTableConfig);
							const targetElId = 'inner-action-add-tls-rule';
							$scope.$root.toggleDropDown(targetElId);
							$timeout(function () {
								const $document = $(document);
								$document.scrollTop($document.height());
							}, 0, false);
						},
					},
				],
				func: function (selectedItems, tableConfig, $event) {
					const targetElId = 'inner-action-add-tls-rule';
					$scope.$root.toggleDropDown(targetElId, $event);
				},
			},
		],
		rulesFields: {
			from: {
				name: 'From',
				id: 'from',
				types: [
					{
						name: 'Any',
						field: FieldTypes.all,
					},
					{
						name: 'Groups',
						field: FieldTypes.groups
					},
					{
						name: 'Sites',
						field: FieldTypes.sites,
					},
					{
						name: 'VPN User',
						field: FieldTypes.accesslogins
					}, {
						name: 'Hosts',
						field: FieldTypes.subnets
					}, {
						name: 'Networks',
						field: FieldTypes.ipRanges
					},
					{
						name: 'Floating Ranges',
						field: FieldTypes.floatingIps
					}
				]
			},
			what: {
				name: 'What',
				id: 'what',
				types: [
					{
						name: 'Any',
						field: FieldTypes.all,
					},
					{
						name: 'Applications',
						field: FieldTypes.allApps,
					},
					{
						name: 'Custom Applications',
						field: FieldTypes.customApplications,
					},
					{
						name: 'Categories',
						field: FieldTypes.categories,
					},
					{
						name: 'Custom Categories',
						field: FieldTypes.customCategories,
					},
					{
						name: 'Services',
						field: FieldTypes.services
					},
					{
						name: 'Custom Service',
						field: FieldTypes.customService,
					},
					{
						name: 'Fully Qualified Domain Name',
						field: FieldTypes.FQDN,
					},
					{
						name: 'Domain Name',
						field: FieldTypes.TLD,
					},
					{
						name: 'IP Range',
						field: FieldTypes.adhocIpRange,
					},
					{
						name: 'Countries',
						field: FieldTypes.countries,
					},
					{
						name: 'Remote ASN',
						field: FieldTypes.asn,
					},
					{
						name: 'Protocol/Port',
						field: FieldTypes.portsProtocols,
					}
				]
			}},
		fields: [
			{
				'label':'s',
				'path':'arrows',
				'template':`<div class="arrows-wrapper">
						<a title="Move Priority Up" role="button" ng-disabled="items.indexOf(item) === 0" ng-click="tableConfig.changePriority('up', item, $event)"><svg class="icon icon-arrow"><use xlink:href="/public/images/icons/main.svg#icon-toggle-up"></use></svg></a>
						<a title="Move Priority Down" role="button" ng-disabled="items.indexOf(item) === items.length - 1" ng-click="tableConfig.changePriority('down', item, $event)"><svg class="icon icon-arrow"><use xlink:href="/public/images/icons/main.svg#icon-toggle-down"></use></svg></a>
					</div>`,
			},
			{
				label: 'a',
				path: 'item',
				template: '<single-tls-inspection-rule item="item" table-config="tableConfig">',
				noSort: true
			},
		],
		defer: true,
		 searchPredicate: function(item, valueToSearch) {
			 return (item.description.toLowerCase().includes(valueToSearch)) ||
				 (Object.values(item.from).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
				 (Object.values(item.what).some(x => x?.display_name?.toLowerCase().includes(valueToSearch))) ||
				 (item.action.toLowerCase().includes(valueToSearch));
		 },
		pageSize: 10,
		hideCheckboxes: true,
		noAutoSelect: true,
		nameField: 'description',
		innerLoader: true,
		items: [],
		allowPropagation: true,
		keepPageOnRefresh: true,
		changePriority: function (direction, item, $event) {
			const index = this.items.indexOf(item);
			$event.stopPropagation();
			var $thisEl = $($element[0]);
			$thisEl.find('.order-change').removeClass('order-change');
			if ((index === 0 && direction === 'up') || (index === this.items.length - 1 && direction === 'down') || index < 0 || item.systemRule) {
				return;
			}

			const targetPriority = item.priority + (direction === 'up' ? -1 : 1);
			const sourcePriority = item.priority;

			if (index !== 0 && direction === 'up') {
				const targetItem = this.items[index - 1];
				if (targetItem.systemRule) {return;}

				targetItem.priority = sourcePriority;
				swapRules(this.items, index, index - 1);
			}
			if (index !== this.items.length - 1 && direction !== 'up') {
				const targetItem = this.items[index + 1];
				if (targetItem.systemRule) {return;}
				targetItem.priority = sourcePriority;
				swapRules(this.items, index, index + 1);
			}

			item.priority = targetPriority;

			this.refreshViewItems = new Date().getTime();

			indexesChangedOrder.forEach(function (i) {
				$thisEl.find('.row-' + i).first().addClass('order-change');
			});

			indexesChangedOrder = [];
		},
		deleteRule: function deleteRule(item, $event) {
			let itemIndexToRemove = $scope.tlsInspectionRulesTableConfig.items.indexOf(item);
			let deletedPriority = item.priority;
			$scope.tlsInspectionRulesTableConfig.items.splice(itemIndexToRemove, 1);
			$scope.tlsInspectionRulesTableConfig.items.forEach(function (item) {
				if (item.priority > deletedPriority) {
					item.priority--;
				}
			});
		},
		parseData: function () {
			var items = [];
			if ($scope.account) {
				if ($scope.account.tlsInspectionConfig) {
					items = $scope.account.tlsInspectionConfig.tlsInspectionRules || [];
				}
			}
			items = items.sort(function (o1, o2) {
				return o1.priority - o2.priority;
			});
			$scope.tlsInspectionRulesOrig = angular.copy(items);
			// $scope.tlsInspectionActionsOrig = angular.copy($scope.tlsActions);

			return items;
		},
	}

	 function addRule(tableConfig, position) {
		 if (!tableConfig.items) {
			 tableConfig.items = [];
		 }

		 let newRule = getNewDefaultRule(tableConfig.items, position);

		 if (position === 0) {
		 	tableConfig.items.forEach((item) => item.priority++);
			tableConfig.items.splice(0, 0, newRule);
		 } else {
			 tableConfig.items.push(newRule);
		 }
	 }

	 var swapRules = function (arr, indexA, indexB) {
		 var temp = arr[indexA];
		 arr[indexA] = arr[indexB];
		 arr[indexB] = temp;
		 indexesChangedOrder.push(indexA);
		 indexesChangedOrder.push(indexB);
	 };

	 var getNewDefaultRule = function getNewDefaultRule(itemsCollection, position) {
		 var nextNum = itemsCollection.length + 1;
		 var newRule = {
			 name: 'TLS Rule ' + nextNum,
			 id: GeneralUtilsService.getRandomId(),
			 description: 'TLS Rule ' + nextNum,
			 from: [FieldsService.getFieldTypes().all.output()],
			 ruleEnabled: true,
			 priority: position === 0 ? position : itemsCollection.length+1,
			 what: [FieldsService.getFieldTypes().all.output()],
		 };

		 newRule.priority = (position || position === 0 ? position + 1 : nextNum);
		 newRule.action = 'Bypass';
		 return newRule;
	 };


	 $scope.tlsInspectionActionConfig = {
		 dataURL: function () {
			 return null;
		 },
		 defer: false,
		 showTable: false,
		 pageSize: DEFAULT_PAGE_SIZE,
		 fixedLayout: true,
		 fields: [
			 { label: 'Protect Against', path: 'name', template: '<span>{{item.name | capitalize }}</span>', noSort: true },
			 { label: 'Action', path: 'action', template: "<div class='action-wrapper' ng-attr-title='{{tableConfig.actionData[item.action].name}}' title='{{tableConfig.actionData[item.action].name}}'><svg id='action_{{item.name | removeSpecialChars}}' title='{{tableConfig.actionData[item.action].name}}.Click to change' class='url-action-button {{tableConfig.actionData[item.action].class}} icon icon-{{tableConfig.actionData[item.action].icon}}' ng-click='tableConfig.changeAction(item)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.action].icon}}'></use></svg></div>", noSort: true },
		 ],
		 type: 'TlsInspection',
		 changeAction: function (item) {
			 var itemName = $filter('removeSpecialChars')(item.name);
			 $scope.$root.$emit('$openPopup', 'actions', 'action_' + itemName);
			 $scope.actionsConfig.rule = item;
		 },
		 selectedItems: [],
		 hideHead: true,
		 noSearch: true,
		 hideCheckboxes: true,
		 actions: false,
		 parseData: function () {
			 var items = [];
			 if ($scope.account.tlsInspectionConfig && $scope.account.tlsInspectionConfig.tlsInspectionConfigActions.length > 0) {
				 items = $scope.account.tlsInspectionConfig.tlsInspectionConfigActions || [];
			 }

			 if (items.length === 0) {
				 items.push({
					 name: 'Untrusted Server Certificates', action: 'PROMPT',
				 });
			 }
			 $scope.tlsInspectionActionsOrig = angular.copy(items);
			 return items;
		 },
		 ruleActions: ['ALLOW', 'BLOCK', 'PROMPT'],
		 actionData: {
			 ALLOW: { name: 'Allow', icon: 'allow', class: 'action-allow' },
			 BLOCK: { name: 'Block', icon: 'block', class: 'action-block' },
			 PROMPT: { name: 'Prompt', icon: 'prompt', class: 'action-alert' },
		 },
	 };

	$scope.tlsInspectionRulesConfig = {
		dataURL: function () {
			return null;
		},
		defer: false,
		showTable: false,
		pageSize: DEFAULT_PAGE_SIZE,
		fixedLayout: true,
		fields: [
            { label: 'Protect Against', path: 'name', template: '<span>{{item.name | capitalize }}</span>', noSort: true },
            { label: 'Action', path: 'action', template: "<div class='action-wrapper' ng-attr-title='{{tableConfig.actionData[item.action].name}}' title='{{tableConfig.actionData[item.action].name}}'><svg id='action_{{item.name | removeSpecialChars}}' title='{{tableConfig.actionData[item.action].name}}.Click to change' class='url-action-button {{tableConfig.actionData[item.action].class}} icon icon-{{tableConfig.actionData[item.action].icon}}' ng-click='tableConfig.changeAction(item)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.action].icon}}'></use></svg></div>", noSort: true },
		],
		type: 'TlsInspection',
		changeAction: function (item) {
			var itemName = $filter('removeSpecialChars')(item.name);
			$scope.$root.$emit('$openPopup', 'actions', 'action_' + itemName);
			$scope.actionsConfig.rule = item;
		},
		selectedItems: [],
		hideHead: true,
		noSearch: true,
		hideCheckboxes: true,
		actions: false,
		titleSearch: false,
		editTrigger: function (item, id) {
			$scope.editTrigger(item, id);
		},
		parseData: function () {
			var items = [];
			if (items.length == 0) {
				items.push({
					name: 'Untrusted Server Certificates', action: 'PROMPT', addresses: '',
				});
			}
			$scope.tlsInspection.rules = angular.copy(items);
			$scope.tlsInspectionOrig.rules = angular.copy(items);
			$scope.origRules = angular.copy(items);
			return items;
		},
		ruleActions: ['ALLOW', 'BLOCK', 'PROMPT'],
		actionData: {
			ALLOW: { name: 'Allow', icon: 'allow', class: 'action-allow' },
			BLOCK: { name: 'Block', icon: 'block', class: 'action-block' },
			PROMPT: { name: 'Prompt', icon: 'prompt', class: 'action-alert' },
		},
	};


	$scope.trustedEntitiesConfig = {
		fixedLayout: true,
		dataURL: function () {
			return '/getTrustedEntities?accountId=' + $state.params.accountId;
		},
		fields: [
            { label: 'Name', path: 'name', template: "<span><input type='text' class='form-control' ng-model='item.name' /></span>" },
            { class: 'entry-list', label: 'Members', showOverflow: true, path: 'destinations', noSort: true, template: `
				<entry-list items='item.destinations' capitalize=true root='item' field='destinations' id='destinations{{$parent.$index}}'
				add-items='tableConfig.selectDestinations(item,field,id)' icons='tableConfig.icons' fields='tableConfig.selectionFields.destinations' editor="true" big-mode="true"></entry-list>`
			},
            { label: 'Comment', path: 'comment', template: "<span><input type='text' class='form-control' ng-model='item.comment' /></span>" },
            { label: 'Date', path: 'creationDate', template: "<span>{{item.creationDate | date:'yyyy/MMM/dd'}}</span>" },
		],
		selectionFields: fieldsForType.trustedEntities,
		selectDestinations: function (item, field, id) {
			$scope.scopeSelection = { item: item };
			$scope.showDest = 'service';
			$scope.appsConfig.selectedItems = [];
			$scope.categoriesConfig.selectedItems = [];
			$scope.customCategoriesConfig.selectedItems = [];
			$scope.urlCategoriesConfig.selectedItems = [];
			$scope.servicesConfig.selectedItems = [];
			$scope.customAppsConfig.selectedItems = [];
			$scope.scopeSelection.item.destinations.forEach(function (entity) {
				if (entity.type === 'App') {
					if (entity.id === 'Any') {

					} else {
						$scope.appsConfig.selectedItems.push(entity);
					}
				} else if (entity.type === 'AppCategory') {
					$scope.categoriesConfig.selectedItems.push(entity);
				} else if (entity.type === 'URLFilter') {
					$scope.urlCategoriesConfig.selectedItems.push(entity);
				} else if (entity.type === 'Service') {
					$scope.servicesConfig.selectedItems.push(entity);
				} else if (entity.type === 'CustomApp') {
					$scope.customAppsConfig.selectedItems.push(entity);
				} else if (entity.type === 'CustomCategory') {
					$scope.customCategoriesConfig.selectedItems.push(entity);
				}
                // IP & TLD are handled separately
			});
			$scope.newIPApplication.ips = $scope.scopeSelection.item.destinations.filter(function (dest) { return dest.type === 'IP'; }).map(function (dest) { return dest.name; }).join();
			$scope.freeText = $scope.scopeSelection.item.destinations.filter(function (dest) { return dest.type === 'TLD'; }).map(function (dest) { return dest.name; }).join();
			$scope.fqdnFreeText = $scope.scopeSelection.item.destinations.filter(function (dest) { return dest.type === 'FQDN'; }).map(function (dest) { return dest.name; }).join();
			$scope.destContext = 'TRUSTED_ENTITIES';
			$scope.$root.openPopup('destinationDlg');
		},
		icons: $scope.icons,
		selectedItems: [],
		processData: function (items, data) {
			items.forEach(function (item) {
				item.customServices.forEach(function (service) {
					item.destinations.push({ id: service, type: 'IP', name: service });
				});

				item.fqdns.forEach(function (fqdn) {
					item.destinations.push({ id: fqdn, type: 'FQDN', name: fqdn });
				});

				item.topLevelDomains.forEach(function (tld) {
					item.destinations.push({ id: tld, type: 'TLD', name: tld });
				});
			});
			$scope.origTrustedEntities = angular.copy(items);
		},
		specialActions: [
			{
				icon: 'add',
				tooltip: 'Add',
				func: function (selectedItems, config) {
					var randomId = Math.floor((Math.random() * 100000000000000) + 1);
					if (!config.items) {
						config.items = [];
					}
					config.items.unshift({ name: '', comment: '', destinations: [], date: new Date(), topLevelDomains: [], customServices: [], fqdns: [], id: randomId * -1 });
				},
			},
			{
				icon: 'delete',
				tooltip: 'Delete',
				func: function (selectedItems, config) {
					$scope.removeItems(selectedItems, config);
				},
			},
		],
		actions: [],
		noSearch: true
	};

	$scope.avExceptionsConfig = {
		fixedLayout: true,
		dataURL: function () {
			return '/getAvExceptions?accountId=' + $state.params.accountId;
		},
		fields: [
                { label: 'File Name', path: 'name', template: '<span>{{item.fileName}}</span>' },
                { label: 'SHA-256', path: 'hash', template: '<span>{{item.hash}}</span>' },
                { label: 'Comment', path: 'comment', template: '<span>{{item.comment}}</span>' },
                { label: 'Expiration Date', path: 'creationDate', template: "<div><span ng-if='item.expirationDate > 0'>{{item.expirationDate | date:'yyyy-MM-dd HH:mm'}}</span><span ng-if='item.expirationDate == 0'>Forever</span></div>" },
                { label: 'Last Modified', path: 'lastModified', template: "<span>{{item.lastModified | date:'yyyy/MMM/dd'}}</span>" },
		],
		icons: $scope.icons,
		selectedItems: [],
		processData: function (items, data) {
			$scope.origAvException = angular.copy(items);
		},
		type: 'avException',
		actions: ['remove'],
		noSearch: true,
	};

	$scope.removeItems = function (selectedItems, config) {
		const len = selectedItems.length;
		if (len === 0) {
			$scope.$root.alert('Please select items to delete');
			return;
		}

		const itemsToDelete = [];
		selectedItems.forEach(function (item) {
			itemsToDelete.push(item.id);
		});

		const itemsMessage = len === 1 ? 'one item' : len + ' items';
		$scope.$root.confirm('Are you sure you want to remove ' + itemsMessage + '?', function () {
			store.remove({
				type: 'TRUSTEDENTITIES',
				items: itemsToDelete,
				success: function (data) {
					itemsToDelete.forEach(function (item) {
						let pos = null;
						for (let i = 0; i < config.items.length; i++) {
							if (config.items[i].id === item) {
								pos = i;
								break;
							}
						}
						if (pos != null) {
							config.items.splice(pos, 1);
						}
					});
					config.selectedItems = [];

					$scope.$root.handleServerResponse(data, '', 'Items removed successfully');
					$scope.datamodifiedTrustedEntities = new Date().getTime();
				},
			});
		});
	};

	 $scope.setTlsInspectionAction = function (popup) {
		 $scope.actionsTlsInspectionConfig.rule.action = $scope.actionsTlsInspectionConfig.selectedAction;
		 $scope.$root.$emit('$closePopup', popup);
	 };

	$scope.setAction = function (popup) {
		$scope.actionsConfig.rule.action = $scope.actionsConfig.selectedAction;
		$scope.$root.$emit('$closePopup', popup);
	};

	function setChanges(type, reset) {
         if (type === 'SYSLOG') {
			$scope.datamodifiedSyslog = new Date().getTime();
			if (reset) {
				$scope.syslog = angular.copy($scope.origSyslog);
			} else {
				$scope.origSyslog = angular.copy($scope.syslog);
			}
		} else if (type === 'account') {
		    if($scope.$root.tags && $scope.$root.tags.includes('QOS_ALERTS')){
		        FailoverConfigurationService.getConfiguration($scope.account.id, null, (data) => {
                    $scope.account.failoverConfiguration = data;
		        });
		    }
			$scope.mailingListConfig.adminMails = $scope.account.adminMails;
			var targetRange = $scope.account.vpnRange.substr(0, $scope.account.vpnRange.lastIndexOf('.'));
			if(!$scope.ipAllocationProperties){
                $scope.ipAllocationProperties = {};
			}
			$scope.ipAllocationProperties.wasChanged = false;
			if (reset) {
				$scope.account = angular.copy($scope.orig);
			} else {
				$scope.orig = angular.copy($scope.account);
			}
            $scope.proxyFileConfigProperties.entity = $scope.account;
            $scope.proxyFileConfigProperties.orig = $scope.orig;
			$scope.publicIpsNum = $scope.account && $scope.account.licensedIpsToAllocate;
		}
		else if(type === "General Properties" || type === "Advanced Configuration"){
		     $scope.origGeneralProperties = angular.copy($scope.account.generalProperties);
		}

		initPortForwardingRules();
		initTlsInspection();

		initDevicePosture();
	}

	function initDevicePosture (){
		if ($scope.$root.tags.includes('DEVICE_POSTURE_POC') && $scope.account) {
			if (!$scope.account.accessSettings) {
				$scope.account.accessSettings = { name: 'AccessSettings'};
			}

			$scope.origAccessSettings = angular.copy($scope.account.accessSettings);
		}
	}


	$scope.tableConfig = {
	    hasChanges: $scope.$root.hasChanges,
		noAutoCheckboxSelect: true,
		mode: 'list',
		afterUpdate: function () {
			if (!$scope.loaded) {
				return;
			}

			if ($scope.$root) {
				$scope.$root.updateScroll('.pane.left .nano');
			}
		},
		clientSideSearch: true,
		defer: true,
		dataURL: function () {
			return null;
		},
		fields: [
            { label: 'Name', path: 'name' },
		],
		height: $scope.getContentHeight(),
		hideCheckboxes: true,
		pageSize: -1,
		parseData: function () {
			return categories;
		},
		liveFilter: (item) => {
			return (!item.requireTag || ($scope.$root.tags && $scope.$root.tags.includes(item.requireTag))) &&
				(!item.requireTags || ($scope.$root.tags && item.requireTags.some(tag => $scope.$root.tags.includes(tag)))) &&
				(!item.hideOnTag || ($scope.$root.tags && !$scope.$root.tags.includes(item.hideOnTag)));
		},
		searchId: $state.params.category,
		titleSearch: 'Category',
		onSelect: function (index, item) {
			if ($scope.currentCategory && $scope.$root.hasChanges()) {
				setChanges(($scope.currentCategory.name === 'Directory Services') ? $scope.currentCategory.name : 'account', true);
			}
			$scope.changeCategory(item);
			firstLoad = false;
			$scope.updateRightScroll();
			$timeout(function () {
				$('[data-toggle="tooltip"]').tooltip();
			}, 1, false);
		},
	};

	$scope.mailingListConfig = {
		fixedLayout: true,
		nonAdminsCount: function (items) {
			if (!items) return null;
			for (var i = 0; items[i]; i++) {
				if (items[i].address) {
					return true;
				}
			}

			return false;
		},
		adminsCount: function (items) {
			if (!items) return null;
			for (var i = 0; items[i]; i++) {
				if (!items[i].address) {
					return true;
				}
			}

			return false;
		},
		filterNonAdmins: function (item) {
			return !!item.address;
		},
		filterAdmins: function (item) {
			return !item.address;
		},
		dataURL: function () {
			return '/getMailingLists?accountId=' + $state.params.accountId;
		},
		showTable: false,
		fields: [
            { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
            { label: 'Edit Members', path: 'edit', template: "<svg  id='editItems_{{$parent.$index}}' class='icon icon-edit' ng-show='(item.type == \"REGULAR\") || (item.type == \"SYSTEM\" && tableConfig.isSystemLogin)' ng-click='tableConfig.editItem(item,$parent.$index)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-edit'></use></svg>" },
            { label: 'Members', path: 'items', template: "<div id='list_{{$parent.$index}}' class='members-list'><div class='long-list' ng-if='tableConfig.nonAdminsCount(item.items) > 0'><span class='admins-title'>Non-Admins: </span><span ng-repeat='mail in item.items | filter: tableConfig.filterNonAdmins'>{{mail.address}}<span ng-if='!$last'>, </span></span></div><span class='admins-title' ng-if='tableConfig.adminsCount(item.items) > 0'>Admins: </span><span ng-repeat='mail in item.items | filter: tableConfig.filterAdmins'>{{tableConfig.adminMails[mail.id]?tableConfig.adminMails[mail.id]:'N/A'}}<span ng-if='!$last'>, </span></span></span></div>" },
            { label: 'Type', path: 'type', template: "<span>{{item.type == 'REGULAR'?'User Defined':'Predefined'}}</span>" },
		],
		type: 'MailingList',
		selectedItems: [],
		adminMails: null,
		editItem: function (item, index) {
			$scope.scopeSelection = { item: item };
			$scope.newMailDef.freeText = '';
			$scope.adminsConfig.selectedItems = [];
			$scope.scopeSelection.item.items.forEach(function (mail) {
				if (mail.address) {
					$scope.newMailDef.freeText += (mail.address + ',');
				}				else {
					$scope.adminsConfig.selectedItems.push({ id: mail.id });
				}
			});

			if ($scope.newMailDef.freeText) {
				$scope.newMailDef.freeText = $scope.newMailDef.freeText.substring(0, $scope.newMailDef.freeText.length - 1);
			}

			$scope.$root.openPopup('members');
		},
		specialActions: [
			{
				func: function () {
					$scope.newList = { name: '', type: 'REGULAR', items: [] };
					$scope.$root.openPopup('addListDlg');
				},
				icon: 'add',
				tooltip: 'New',
			},
			{
				func: function (selectedItems) {
					selectedItems.forEach(function (item) {
						for (var i = 0; i < $scope.mailingListConfig.items.length; i++) {
							var list = $scope.mailingListConfig.items[i];
							if (list.name == item.name) {
								$scope.mailingListConfig.items.splice(i, 1);
								break;
							}
						}
					});
				},
				icon: 'delete',
				tooltip: 'Delete',
			},
		],
		processData: function (items, data) {
			$scope.origMailingDefinition = angular.copy(items);
			$scope.mailingLists = [];
			items.forEach(function (list) {
				$scope.mailingLists.push(list.name);
			});
		},
		actions: [],
		clientSidePaging: true,
		isSystemLogin: isSystemLogin,
		noSearch: true,
	};

	$scope.alwaysOnConfigProperties = {wasChanged: false};

	$scope.setListMembers = function () {
		$scope.scopeSelection.item.items = [];
		var mails = $scope.newMailDef.freeText.split(',');
		mails.forEach(function (mail) {
			if (mail) {
				$scope.scopeSelection.item.items.push({ address: mail });
			}
		});
		$scope.adminsConfig.selectedItems.forEach(function (admin) {
			$scope.scopeSelection.item.items.push({ id: admin.id });
		});
		$scope.$root.closePopup('members');
	};


	$scope.addList = function () {
		if ($scope.newList.name) {
			$scope.mailingListConfig.items.push($scope.newList);
			$scope.$root.closePopup('addListDlg');
		} else {
			alert('Please enter mailing list name');
		}
	};

    // init watcher for deep watching (workaround for Angular bug)
	function initDataModifiersWatchers() {
		$scope.remotePortForwarding.remotePortForwardingDataModified =[];
		for (var i = 0; i < $scope.publicIpsNum; i++) {
			$scope.remotePortForwarding.remotePortForwardingDataModified.push(false);
		}
	}

    $scope.hasGeneralPropertiesChanges = function() {
        if($scope.origGeneralProperties && $scope.account.generalProperties){
           return !angular.equals($scope.origGeneralProperties, $scope.account.generalProperties);
        }

        if (!$scope.account ||!$scope.account.isGeneralPropertiesUpdated){
            return false;
        }
        return $scope.account.isGeneralPropertiesUpdated;
    }

	$scope.$root.hasChanges = function () {
		if (!$scope.currentCategory) return;

		return $scope.currentCategory.hasChanges();
	};


	var initPortForwardingRules = function () {
		if (!$scope.account || !$scope.allocatedIps) {
			return;
		}

		$scope.publicIpsNum = $scope.account && $scope.account.licensedIpsToAllocate;
		$scope.rpfPageSize = DEFAULT_PAGE_SIZE;
		$scope.rpfCurrentPage = 0;
		$scope.numberOfPages=Math.ceil($scope.publicIpsNum/$scope.rpfPageSize);

		$scope.remotePortForwarding.portForwardingMetadata = { locations: [], ips: {}, portItems: {}, ids: {} };


		for (let key in $scope.account.remotePortForwardingRules) {
			let rule = $scope.account.remotePortForwardingRules[key];
			const rpfBlockListExists = rule.remotePortForwarding.some(rpf => rpf.blockList);
			if (rpfBlockListExists) {
				$scope.usingRpfBlockList = true;
			}

			$scope.remotePortForwarding.portForwardingMetadata.locations[key] = rule.locationId;

			if (rule.publishedIpsId) {
				$scope.remotePortForwarding.portForwardingMetadata.ips[key] = $scope.allocatedIps.filter(function(publishedIp) { return publishedIp.id === LocationService.publishedIpIdPrefix + rule.publishedIpsId})[0];
			} else if (rule.allocatedIpsId) {
				$scope.remotePortForwarding.portForwardingMetadata.ips[key] = $scope.allocatedIps.filter(function(allocatedIP) { return allocatedIP.id === LocationService.allocatedIpIdPrefix + rule.allocatedIpsId})[0];
			} else {
				$scope.remotePortForwarding.portForwardingMetadata.ips[key] = { ip: rule.externalIp, popId: rule.popId, location: rule.locationId };
			}
			$scope.remotePortForwarding.portForwardingMetadata.portItems[key] = rule.remotePortForwarding;
			$scope.remotePortForwarding.portForwardingMetadata.ids[key] = rule.id;
		}


        // for "dirty" check (for "done" button)
		$scope.portForwardingMetadataOrig = angular.copy($scope.remotePortForwarding.portForwardingMetadata);

        // load table after metadata calculation
		for (var i = 0; i < $scope.publicIpsNum; i++) {
			$scope.remotePortForwarding.remotePortForwardingDataModified[i] = new Date().getTime();
		}
	};

	var initTlsInspection = function () {
		if (!$scope.account) {
			return;
		}
		$scope.tlsInspectionOrig = angular.copy($scope.account.tlsInspectionConfig);
		$scope.datamodifiedTlsInspection = new Date().getTime();
	};

    var remotePortForwardingSave = function (fields) {

        var saveFunc = function() {
            sendAccountSave(fields);
        };

        let allowedIPsArray = $scope.account.remotePortForwardingRules
            .flatMap(rule => rule.remotePortForwarding)
            .map(rule => rule.allowedRemoteIps);

        let hasAnyAccessConfigured = false;

        for(let ipString of allowedIPsArray) {
            if(ValidationService.isAnyIpAllowed(ipString).isValid) {
               hasAnyAccessConfigured = true;
               break;
            }
        }

        if(hasAnyAccessConfigured) {
            var warningText = $sce.trustAsHtml(`
                <p>The value for the Allowed Remote IPs field means that any IP address can reach the internal network.
                This is a potential security risk, and we strongly recommend that instead you use a specific IP address or range.</p>
                <p>Note: When the Allowed Remote IPs field is blank, the value is considered as 0.0.0.0/0.</p>
            `);

            $rootScope.confirm(warningText, saveFunc, null, null, $scope.hideLoading, null, null, true);
        } else {
            saveFunc();
        }

    };

	var updatePortForwardingRules = function () {
		$scope.account.remotePortForwardingRules = [];

        // Removed this if so we keep RPF data even if not enabled.
        // if ($scope.account.remotePortForwardingEnabled) {
		for (var key in $scope.remotePortForwarding.portForwardingMetadata.ips) {
			var forwardingPort = $scope.remotePortForwarding.portForwardingMetadata.ips[key];
			if (forwardingPort) {
				$scope.account.remotePortForwardingRules.push({ id: $scope.remotePortForwarding.portForwardingMetadata.ids[key] ? $scope.remotePortForwarding.portForwardingMetadata.ids[key] : GeneralUtilsService.getRandomId(),
					name: 'portForwarding',
					externalIp: forwardingPort.ip,
					popId: forwardingPort.popId,
					locationId: $scope.remotePortForwarding.portForwardingMetadata.locations[key],
					remotePortForwarding: $scope.remotePortForwarding.portForwardingMetadata.portItems[key] ? $scope.remotePortForwarding.portForwardingMetadata.portItems[key] : [] });
				// forwardingPort with an id is one that is the new rpf which is connected to either allocated ip or published ip
				if (forwardingPort.id) {
					if (forwardingPort.id.indexOf(LocationService.allocatedIpIdPrefix) == 0) {
						$scope.account.remotePortForwardingRules[$scope.account.remotePortForwardingRules.length-1].allocatedIpsId = forwardingPort.id.substring(LocationService.allocatedIpIdPrefix.length);
						delete $scope.account.remotePortForwardingRules[$scope.account.remotePortForwardingRules.length-1].publishedIpsId;
					} else if(forwardingPort.id.indexOf(LocationService.publishedIpIdPrefix) == 0) {
						$scope.account.remotePortForwardingRules[$scope.account.remotePortForwardingRules.length-1].publishedIpsId = forwardingPort.id.substring(LocationService.publishedIpIdPrefix.length);
						delete $scope.account.remotePortForwardingRules[$scope.account.remotePortForwardingRules.length-1].allocatedIpsId;
					}
				}
			}
		}
	};


    var updateSplitTunnel = function () {
        var id = ($scope.origSplitTunnelId ? $scope.origSplitTunnelId : GeneralUtilsService.getRandomId());
        		$scope.account.splitTunnelConfiguration = [];
//        var tempSplitTunnel = angular.copy($scope.origSplitTunnel[0])
        //        if (!tempSplitTunnel.config) {
        var tempSplitTunnel = {config: []};
        //        }
        if ($scope.splitTunnelConfig && $scope.splitTunnelConfig.items) {
            $scope.splitTunnelConfig.items.forEach(function (st) {tempSplitTunnel.config.push({id:st.id,ip:st.ip,mask:st.mask,action:$scope.splitTunnelDirection.name})});
            tempSplitTunnel.newSaveMethod = true;
            tempSplitTunnel.id = id;
            tempSplitTunnel.name = 'SplitTunnelConfig';
            tempSplitTunnel.type = 'SPLITTUNNELCONFIGURATION';
            $scope.account.splitTunnelConfiguration.push(tempSplitTunnel);
        }
    };

	var updateTlsInspection = function () {

		$scope.account.tlsInspectionConfig.tlsInspectionConfigActions = angular.copy($scope.tlsInspectionActionConfig.items);
	};


	 var updateTrustedEntities = function () {
		if ($scope.trustedEntitiesConfig.items) {
			$scope.account.trustedEntities = angular.copy($scope.trustedEntitiesConfig.items);

			$scope.account.trustedEntities.forEach(function (trustedEntitiesItem) {
				trustedEntitiesItem.topLevelDomains = [];
				trustedEntitiesItem.customServices = [];
				trustedEntitiesItem.fqdns = [];
				var len = trustedEntitiesItem.destinations.length;
				while (len--) {
					var dest = trustedEntitiesItem.destinations[len];
					if (dest.type === 'TLD') {
						trustedEntitiesItem.topLevelDomains.push(dest.id);
						trustedEntitiesItem.destinations.splice(trustedEntitiesItem.destinations.indexOf(dest), 1);
					}
					if (dest.type === 'FQDN') {
						trustedEntitiesItem.fqdns.push(dest.id);
						trustedEntitiesItem.destinations.splice(trustedEntitiesItem.destinations.indexOf(dest), 1);
					}
					if (dest.type === 'IP') {
						trustedEntitiesItem.customServices.push(dest.id);
						trustedEntitiesItem.destinations.splice(trustedEntitiesItem.destinations.indexOf(dest), 1);
					}
				}
			});
		}
	};

    //client side should only validate CIDR range to be between /16 and /24.
    //any other validation is done on server side.
    function validateVpnRange(vpnRange) {
        if(!vpnRange){
            //this case will be validated on server
            return true;
        }
        var slashPosition = vpnRange.lastIndexOf('/');
        if(slashPosition) {
            var subnet = vpnRange.slice(slashPosition + 1);
            if(subnet && !isNaN(subnet)) {
                return (subnet >=16 && subnet <=24);
            }
        }
        //this case will be validated on server.
        return true;
    }

	$scope.hideLoading = function () {
		$scope.loading = false;
	};

	$scope.saveChanges = function () {
		$scope.loading = true;

		if ($scope.currentCategory.preSave) {
			$scope.currentCategory.preSave();
		}

		if ($scope.currentCategory.validate) {
			if (!$scope.currentCategory.validate()) {
				$scope.loading = false;
				return;
			}
		}

		var fields = '';

		if ($scope.currentCategory.fields) {
			if (typeof $scope.currentCategory.fields === 'function') {
				fields = $scope.currentCategory.fields();
			} else {
				fields = $scope.currentCategory.fields;
			}
		}

		if ($scope.currentCategory.save) {
			$scope.currentCategory.save(fields);
			return;
		}

        // send save request
		sendAccountSave(fields, $scope.currentCategory.onSaveSuccessCallback);
	};

    // listener fo changes in the general properties, properties field sent to this function is the diff after equal check
    $scope.generalPropertiesChanged = function (properties, isGeneralPropertiesUpdated) {
        if (isGeneralPropertiesUpdated){
            $scope.generalPropertiesToSave = properties;
        }
        $scope.account.isGeneralPropertiesUpdated = isGeneralPropertiesUpdated;
    }

	// used to update the scope account and views related to an updated model (after save or on initial load)
	function setAccount(data) {
        //will be added by the general-property component itself
        delete data.generalProperties;
        data.isGeneralPropertiesUpdated = false;

		$scope.account = data;
		setChanges('account');
		// setMailingLists();
		$scope.mailingLists = [];
		if (data.mailingDefinition) {
			data.mailingDefinition.mails.forEach(function (list) {
				$scope.mailingLists.push(list.name);
			});
		}
		$scope.dnsdatamodified = new Date().getTime();
		$scope.dnssettingsdatamodified = new Date().getTime();
		$scope.datamodifiedTlsInspection = new Date().getTime();
		$scope.datamodifiedTrustedEntities = new Date().getTime();
		$scope.wmicontrollersdatamodified = new Date().getTime();
		$scope.reversednsmodified = new Date().getTime();
		$scope.uaExceptionsmodified = new Date().getTime();
		$scope.egressdatamodified = new Date().getTime();
		$scope.datamodifiedsplittunnel = new Date().getTime();

		$scope.certTableDataModified = new Date().getTime();
		$scope.certDetailsDataModified = new Date().getTime();

		setChanges('Advanced Configuration');

		$scope.$digest();
		$scope.$broadcast('modelReloadedEvent', {model: data});
		$scope.$broadcast('reset-properties');
	}

    function sendAccountSave(fields, callback) {
        if ($scope.account.isGeneralPropertiesUpdated){
            $scope.account.generalProperties = $scope.generalPropertiesToSave;
        }

        updateAccountItemsToDelete();

		$scope.account.newSaveMethod = true;
        store.save({
            path: '/edit',
            data: $scope.account,
            dataObj: 'json',
            queryParams: {
                accountId: $state.params.accountId,
                save: true,
                fields: fields,
            },
            success: function (data) {
				$scope.loading = false;
                $scope.$root.handleServerResponse(data, '', 'Account settings saved successfully');
                if (data.status !== 'ERROR') {
                    if (isAlwaysOnSave()){
                        $scope.alwaysOnConfigProperties.onSaveCallback();
                    }
                    loadAccount();

                    if (callback)
                        callback(data);
                }
            },
        });
    }

    // Adding items to delete to account to avoid removals of entities in list in case of paging or general properties case
    // in which the a non-system user gets and sends only his visible properties and might override the system general properties
    function updateAccountItemsToDelete(){
        if (!$scope.account.itemsToDelete) {
            $scope.account.itemsToDelete = {};
        }

        if(!$scope.account.itemsToDelete.generalProperties) {
            $scope.account.itemsToDelete.generalProperties = [];
        }

		if(!$scope.account.itemsToDelete.trustedEntities) {
			$scope.account.itemsToDelete.trustedEntities = [];
		}
    }

	function isAlwaysOnSave() {
		return $scope.alwaysOnConfigProperties && $scope.alwaysOnConfigProperties.wasChanged;
    }

	$scope.saveMailingLists = function () {
        // mailing list
		$scope.account.mailingDefinition.mails = $scope.mailingListConfig.items;

		store.save({
			path: '/saveMailingLists',
			queryParams: {
				accountId: $state.params.accountId,
			},
			data: $scope.account.mailingDefinition,
			dataObj: 'mailingLists',
			success: function (data) {
				$scope.loading = false;
				$scope.$root.handleServerResponse(data, 'mailinglist', 'Mailing lists saved successfully');
                // handle ERROR response from server
				if (data.status != 'ERROR') {
					$scope.mailingLists = [];
					data.mails.forEach(function (list) {
						$scope.mailingLists.push(list.name);
					});
					setMailingLists();
					$scope.scopeSelection.addresses = $scope.newMailDef.name;
				}
			},
		});
	};

	$scope.changeCategory = function (category) {
		$scope.currentCategory = category;
		if ($scope && $scope.$root) {
			$scope.$root.clearErrors();
			$scope.$root.currentCategory = category.name;
		}

        $timeout(function () {
            const $headings = $('#configPage').find('.accordion-heading');
            if($headings.length == 1){
                $headings.first().click();
            }
        }, 1, false);

	};

	function setMailingLists() {
		$scope.origMailingDefinition = angular.copy($scope.account.mailingDefinition.mails);
		$scope.datamodifiedMailingList = new Date().getTime();
	}

	function togglePassword() {
		var $this = $(this);
		$this.toggleClass("fa-eye fa-eye-slash");
		var input = $($(this).attr("toggle"));
		if (input.attr("type") == "password") {
			input.attr("type", "text");
		} else {
			input.attr("type", "password");
		}
	}

	function keyUpPasswordField() {
		if($(this).val())
			$(".glyphicon-eye-open").show();
		else
			$(".glyphicon-eye-open").hide();
	}

	$(".toggle-password").on("click", togglePassword);
    $("#passwordfield").on("keyup", keyUpPasswordField);


	$scope.adminsConfig = {
		titleSearch: true,
		dataURL: function () {
			return '/users?accountId=' + $state.params.accountId;
		},
		showTable: false,
		fields: [{ label: 'First Name', path: 'firstName', template: '<span>{{item.firstName}}</span>' },
            { label: 'Last Name', path: 'lastName', template: '<span>{{item.lastName}}</span>' },
            { label: 'E-mail', path: 'email', template: '<span>{{item.email}}</span>' },
		],
		type: 'Admin',
		actions: [],
		selectedItems: [],
		pageSize: DEFAULT_PAGE_SIZE,
	};

	$scope.categoriesConfig = {
		titleSearch: true,
		dataURL: function () {
			return '/categories?accountId=' + $state.params.accountId;
		},
		showTable: false,
		actions: [],
		pageSize: DEFAULT_PAGE_SIZE,
		sortField: 'display_name',
		searchField: 'display_name',
		fields: [{ label: 'Name', path: 'display_name', template: '<span>{{item.display_name | capitalize}}</span>' }],
		type: 'AppCategory',
		selectedItems: [],
	};

	$scope.appsConfig = {
		titleSearch: true,
		dataURL: function () {
			return '/categories?accountId=' + $state.params.accountId;
		},
		showTable: false,
		actions: [],
		pageSize: DEFAULT_PAGE_SIZE,
		sortField: 'display_name',
		searchField: 'display_name',
		fields: [{ label: 'Name', path: 'display_name', template: '<span>{{item.display_name}}</span>' },
            { label: 'Categories', path: 'categories', template: '<span>{{item.categoriesDisplay}}</span>' }],
		type: 'App',
		selectedItems: [],
	};

	$scope.servicesConfig = {
		titleSearch: true,
		dataURL: function () {
			return '/categories?accountId=' + $state.params.accountId;
		},
		showTable: false,
		actions: [],
		pageSize: DEFAULT_PAGE_SIZE,
		sortField: 'display_name',
		searchField: 'display_name',
		fields: [{ label: 'Name', path: 'display_name', template: '<span>{{item.display_name}}</span>' },
			{ label: 'Categories', path: 'categories', template: '<span>{{item.categoriesDisplay}}</span>' }],
		type: 'Service',
		selectedItems: [],
	};

	$scope.customAppsConfig = {
		titleSearch: true,
		dataURL : function () {
			return "/getCustomApps?accountId=" + $state.params.accountId;
		},
		actions: [],
		pageSize:DEFAULT_PAGE_SIZE,
		sortField:"name",
		searchField:"name",
		fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},{"label":"Category","path":"categoryId","template":"<span>{{item.categoryId | capitalize}}</span>"}],
		type : "CustomApp",
		parseData: function (data) {
			var items = [];
			for (var key in data) {
				var item = data[key];
				item.id = item.appId;
				item.type = 'CustomApp';
				item.display_name = item.name;
				items.push(item);
			}
			return items;
		},
		selectedItems:[]
	};

    // Fetch from server another free public IP
    // TODO merge this function with ipAllocationConfig.js
	$scope.addIP = function (index, rule) {
		if (rule.locations[index] == 0) {
			rule.ips[index] = null;
			return;
		}

        // get all allocated IPs to make sure we won't get the same IP again
		var allAllocatedIps = {};
		var counter = 0;
		angular.forEach($scope.ipforwardingRule.ips, function (value, key) {
			if (value.externalIp) {
				allAllocatedIps[counter] = {ip: value.ip, popId:value.popId, location:value.locationId};
				counter++;
			}
		});
		angular.forEach($scope.remotePortForwarding.portForwardingMetadata.ips, function (value, key) {
			if (value.externalIp) {
				allAllocatedIps[counter] = {ip: value.ip, popId:value.popId, location:value.locationId};
				counter++;
			}
		});

        // check if we already assigned IP that we can use
		var ipToUse = null;
		var ipsInUseForThisRule = [];
		angular.forEach(rule.ips, function (value, key) {
			ipsInUseForThisRule.push(value.ip);
		});
		angular.forEach(allAllocatedIps, function (value, key) {
            // Make sure location match
			if (value.location == rule.locations[index]) {
                // make sure we don't already use this IP
				if (ipsInUseForThisRule.indexOf(value.ip) < 0) {
					ipToUse = value;
				}
			}
		});

		if (ipToUse) {
			rule.ips[index] = ipToUse;
			return;
		}


        // send request to the server to assign new IP
		store.fetch({
            data: allAllocatedIps,
            method: 'POST',
            dataObj: 'currentIpsStr',
            path: "getNewIP?accountId=" + $state.params.accountId,
			queryParams: {location: rule.locations[index] },
			success: function (data) {
				if (data == null) {
					rule.ips[index] = { error: 'Not enough free IP addresses in location' };
				}				else {
					rule.ips[index] = data;
				}
			},
		});
	};

	$scope.loadLocations = function () {
		LocationService.getPopLocations($state.params.accountId, updateLocations)
	};

	function updateLocations(data){
	    $scope.locations = data;
    	if (!$scope.locationById)
    	    $scope.locationById = {};
    	data.forEach(function (location) {$scope.locationById[location.id] = location.name;});
    	initLocationsConfig(angular.copy(data));
	}

	$scope.dnsForwardingConfig = {
		id: 'dnsForwarding',
		dataURL: function () {
			return null;
		},
		parseData: function () {
            // the account is usually not defined yet here
			if ($scope.account) {
				return $scope.account.dnsForwarding;
			}
			return [];
		},
		fields: [
            { label: 'Domains', path: 'domains', template: "<span><input type='text' class='form-control' ng-model='item.domains' /></span>" },
            { label: 'IPs', path: 'ips', template: "<span><input type='text' class='form-control' ng-model='item.ips' /></span>" },
		],
		actions: [],
		addAction: function () {
			$scope.account.dnsForwarding.push({ id: GeneralUtilsService.getRandomId(), ips: '', domains: '', name: 'dns' });
			$scope.dnsdatamodified = new Date().getTime();
		},
		specialActions: [
			{ func: function (selectedItems) {
				selectedItems.forEach(function (item) {
					for (var i = 0; i < $scope.account.dnsForwarding.length; i++) {
						var existingItem = $scope.account.dnsForwarding[i];
						if (existingItem.id === item.id) {
							$scope.account.dnsForwarding.splice(i, 1);
							break;
						}
					}
				});
			},
				icon: 'delete',
				tooltip: 'Delete' },
		],
		selectedItems: [],
		noSearch: true,
	};

    $scope.crossConnectNatConfig = {
        id: 'crossConnectNat',
        dataURL: function () {
            return null;
        },
        parseData: function () {
            // the account is usually not defined yet here
            if ($scope.account) {
                return $scope.account.crossConnectNatIps;
            }
            return [];
        },
        fields: [
            { label: 'IP', path: 'ipRange', template: "<span><input type='text' class='form-control' ng-model='item.ipRange' /></span>" },
            { label: 'Description', path: 'description', template: "<span><input type='text' class='form-control' ng-model='item.description' /></span>" },
        ],
        actions: [],
        addAction: function () {
            $scope.account.crossConnectNatIps.push({ id: GeneralUtilsService.getRandomId(), ipRange: '', description: '', name: 'ccnat' });
            $scope.ccnatdatamodified = new Date().getTime();
        },
        specialActions: [
            { func: function (selectedItems) {
                selectedItems.forEach(function (item) {
                    for (var i = 0; i < $scope.account.crossConnectNatIps.length; i++) {
                        var existingItem = $scope.account.crossConnectNatIps[i];
                        if (existingItem.id === item.id) {
                            $scope.account.crossConnectNatIps.splice(i, 1);
                            break;
                        }
                    }
                });
            },
                icon: 'delete',
                tooltip: 'Delete' },
        ],
        selectedItems: [],
        noSearch: true,
    };

	$scope.reverseDnsConfig = {
		id: 'reverseDnsLookup',
		useItemsIndex: true,
		dataURL: function () {
			return null;
		},
		parseData: function () {
            // the account is usually not defined yet here
			var viewips = [];
			if ($scope.account.reverseDnsLookup[0] && $scope.account.reverseDnsLookup[0].ips) {
				$scope.account.reverseDnsLookup[0].ips.forEach(function (ip) {
					viewips.push({ ip: ip });
				});
			}
			$scope.origReverseDns = angular.copy(viewips);
			return viewips;
		},
		fields: [
            { label: 'IPs', path: 'ip', template: "<span><input type='text' class='form-control' ng-model='item.ip' /></span>" },
		],
		actions: [],
		addAction: function () {
			if (!$scope.reverseDnsConfig.items) { $scope.reverseDnsConfig.items = []; }
			$scope.reverseDnsConfig.items.push({ id: GeneralUtilsService.getRandomId(), ip: '' });
		},
		specialActions: [
			{ func: function (selectedItems) {
				selectedItems.forEach(function (item) {
					for (var i = 0; i < $scope.reverseDnsConfig.items.length; i++) {
						var controller = $scope.reverseDnsConfig.items[i];
						if (controller == item) {
							$scope.reverseDnsConfig.items.splice(i, 1);
							break;
						}
					}
				});
			},
				icon: 'delete',
				tooltip: 'Delete' },
		],
		selectedItems: [],
		noSearch: true,
	};

	$scope.saveSyslog = function (callBack) {
		$scope.syslog.pullType = $scope.syslogPullTypes[0].name;
		var path;
		var params;
		if ($scope.syslog.id) {
			path = '/edit';
			params = { syslogId: $scope.syslog.id, save: true, accountId: $state.params.accountId };
		}		else {  // new item
			path = '/add';
			params = { accountId: $state.params.accountId, type: 'Syslog', save: true };
		}

		$scope.syslog.newSaveMethod = true;
		store.save({
			path: path,
			data: $scope.syslog,
			dataObj: 'json',
			queryParams: params,
			success: function (data) {
				$scope.loading = false;
				$scope.$root.handleServerResponse(data, 'syslog', 'Logs Exporter saved successfully');
				if (data.status != 'ERROR') {
					$scope.datamodifiedSyslogdatamodifiedSyslog = new Date().getTime();
					$scope.syslog = data.model;
					$scope.origSyslog = angular.copy($scope.syslog);
					if (callBack) {
						callBack();
					}
				}
			},
		});
	};


	$scope.loadSyslogFormats = function () {
		store.fetch({
			path: 'getSyslogFormats',
			success: function (data) {
				$scope.syslogFormats = data.items;
			},
		});
	};


    $scope.oktaDomains = [
				{
								caption:'.okta-emea.com',
								value:'OKTA_EMEA',
								provider:'OKTA',
				},
				{
								caption:'.okta.com',
								value:'OKTA_COM',
								provider:'OKTA'
				},
				{
								caption:'.oktapreview.com',
								value:'OKTA_PREVIEW',
								provider:'OKTA'
				},
				{
								caption:'.onelogin.com',
								value:'ONELOGIN_COM',
								provider:'ONELOGIN'
				}
    ];


		$scope.ssoProviders = [
				{
								name: 'MICROSOFT',
								value: 'Microsoft Azure',
								domains: false
				},
				{
								name: 'OKTA',
								value: 'Okta',
								domains: true
				},
				{
								name: 'ONELOGIN',
								value: 'OneLogin',
								domains: true,
								requiredTag: "ONELOGIN_AD"
				},
				{
								name: 'GOOGLE',
								value: 'Google',
								domains: false
				},

	];

	 $scope.$watch("externalSystem.ssoConfiguration.provider", function (newVal) {
	 	$scope.showDomain = $scope.ssoProviders.find( p => p.name === newVal).domains;
	 	$scope.suffixLabel = $scope.showDomain ? "Organization Domains" : "Allowed Domains";
	 });

	$scope.loadSyslogPullTypes = function () {
		store.fetch({
			path: 'getSyslogPullTypes',
			success: function (data) {
				$scope.syslogPullTypes = data.items;
			},
		});
	};


	$scope.hasSyslogChanges = function () {
		var syslog = $scope.syslog;
		if (!syslog) return false;
		if (syslog.id < 0) return true; // new syslog
		if (!angular.equals($scope.syslog, $scope.origSyslog)) return true;
		return false;
	};

	$scope.hasDhcpRelayChanges = function () {
		if (!$scope.account) return false;
        if (($scope.account.dhcpConfig.dhcpRelayEnabled != $scope.orig.dhcpConfig.dhcpRelayEnabled) || ($scope.account.dhcpConfig.dhcpRelayServerIp != $scope.orig.dhcpConfig.dhcpRelayServerIp)
         || ($scope.account.dhcpConfig.dhcpRelayTimeout != $scope.orig.dhcpConfig.dhcpRelayTimeout)) return true;

        return false;
    };

    //has one of the components changes
    $scope.hasChanges.dhcpSettings = false;
    $scope.hasChanges.floatingIps = false;
    $scope.hasChanges.mfaConfiguration = false;
    $scope.hasChanges.contactSupport = false;
	 $scope.hasChanges.uploadLog = false;
    $scope.hasChanges.directoryServices = false;
    $scope.hasChanges.lastMileMonitoring = false;
    $scope.hasChanges.macAddressAuthentication = false;
    $scope.hasChanges.maintenancePlan = false;
    $scope.hasChanges.dhcpRelayGroups = false;
    $scope.hasChanges.deviceAuthenticationConfiguration = false;
    $scope.hasChanges.scimProvisioning = false;

    //a listener called by the component when something is changed
    //requires the component name to be updated in $scope.hasChanges object
    $scope.configurationChanged = function(dirty, componentName) {
		$scope.hasChanges[componentName] = dirty;
    };

    $scope.failoverConfigChanged = function(current, previous) {
		$scope.hasChanges.failoverConfiguration = !angular.equals(current, previous);
		$scope.account.failoverConfiguration = current;
    };

	 $scope.componentConfigChanged = function(componentName, current, hasChanges) {
		 $scope.hasChanges[componentName] = hasChanges;
		 $scope.account[componentName] = current;
	 };

	 $scope.changeModel = function (model, dirty, componentName, isNew){
        if(isNew){
        	model.id = GeneralUtilsService.getRandomId();
        	model.name = componentName;
        }

        $scope.account[componentName] = model;
        $scope.hasChanges[componentName] = dirty;
    };

    $scope.hasDnsSettingsChanges = function () {
        if (!$scope.account) return false;
        if (!$scope.account.dnsSettings && !$scope.orig.dnsSettings) return false;
        if (($scope.account.dnsSettings && !$scope.orig.dnsSettings)
         || ($scope.account.dnsSettings.primaryServer !== $scope.orig.dnsSettings.primaryServer)
         || ($scope.account.dnsSettings.secondaryServer !== $scope.orig.dnsSettings.secondaryServer)
         || (!angular.equals($scope.account.dnsSettings.suffixes, $scope.orig.dnsSettings.suffixes))) return true;

        return false;
    };

    $scope.hasDnsForwardingChanges = function () {
        if (!$scope.account) return false;
        return !angular.equals($scope.account.dnsForwarding, $scope.orig.dnsForwarding);
    };

    $scope.hasVpnChanges = function () {
		if (!$scope.account) return false;
        const hasVpnRangeChanged = $scope.account.vpnRange !== $scope.orig.vpnRange
		const hasNoVpnConfigurationFileChanged = $scope.account.noVpnConfigurationFile !== $scope.orig.noVpnConfigurationFile;
		const hasExternalSystemChanged = (!angular.equals($scope.externalSystem, $scope.externalSystemOrig));
		const hasOktaConfigurationChanged = (!angular.equals($scope.oktaConfiguration, $scope.oktaConfigurationOrig));
		const hasScimProvisioningChanged = $scope.hasChanges.scimProvisioning;
		const hasSplitTunnelChanged = $scope.origSplitTunnel && (!angular.equals($scope.splitTunnelConfig.items, $scope.origSplitTunnel)) ;
		const hasSplitTunnelDirectionChanged = $scope.splitTunnelDirectionOrig && $scope.splitTunnelDirectionOrig.name !== $scope.splitTunnelDirection.name;
		const hasEnableAccountSplitTunnelChanged = $scope.account.enableAccountSplitTunnel !== $scope.orig.enableAccountSplitTunnel;
		const hasSplitTunnelEnforcementChanged = $scope.account.splitTunnelEnforcement !== $scope.orig.splitTunnelEnforcement;
		const hasMfaConfigurationChanged = $scope.hasChanges.mfaConfiguration;
		const hasContactSupportChanged = $scope.hasChanges.contactSupport;
		const hasVpnClientPolicyChanged = $scope.hasChanges.uploadLog;
		const hasUserProvisioningMethodChanged = $scope.account.userProvisioningMethod !== $scope.orig.userProvisioningMethod;
		const hasInvitationEmailConfigurationChanged = !angular.equals($scope.account.invitationEmailConfiguration, $scope.orig.invitationEmailConfiguration);
		const hasRegistrationCodeConfigurationChanged = !angular.equals($scope.account.registrationCodeConfiguration, $scope.orig.registrationCodeConfiguration);
		const upgradePolicyChanges = !angular.equals($scope.account.controlUpgradePolicy,$scope.orig.controlUpgradePolicy);
		const hasDeviceAuthenticationConfigurationChanged = $scope.hasChanges.deviceAuthenticationConfiguration;
		const hasCertificateManagementChanged = !angular.equals($scope.account.certificates, $scope.orig.certificates);
		const hasProxyFileConfigurationChanged = $scope.proxyFileConfigProperties.hasChanges && $scope.proxyFileConfigProperties.hasChanges();
		const devicePostureToggleChanged = $scope.$root.tags.includes('DEVICE_POSTURE_POC') && $scope.account.accessSettings && !angular.equals($scope.account.accessSettings.devicePostureEnabled , $scope.origAccessSettings.devicePostureEnabled);

        return hasVpnRangeChanged || hasNoVpnConfigurationFileChanged || hasExternalSystemChanged || hasScimProvisioningChanged || hasSplitTunnelChanged
			|| hasSplitTunnelDirectionChanged || hasEnableAccountSplitTunnelChanged || hasSplitTunnelEnforcementChanged
			|| hasProxyFileConfigurationChanged || hasMfaConfigurationChanged || hasContactSupportChanged
			|| hasUserProvisioningMethodChanged || hasInvitationEmailConfigurationChanged || upgradePolicyChanges
			|| hasRegistrationCodeConfigurationChanged || hasDeviceAuthenticationConfigurationChanged
			|| hasCertificateManagementChanged || hasVpnClientPolicyChanged || hasOktaConfigurationChanged || devicePostureToggleChanged
			;
    };


	$scope.testConnection = function () {
		store.fetch({
			path: '/getSyslog',
			queryParams: { syslog: $scope.syslog },
			success: function (data) {
				$scope.syslog = data;
				setChanges('SYSLOG');
			},
		});
	};


	$scope.selectSysLogTypes = function () {
		$scope.syslogTypesTableConfig.selectedItems = [];
		$scope.syslog.syslogTypes.forEach(function (tag) {
			$scope.syslogTypesTableConfig.selectedItems.push(tag);
		});
		$scope.$root.openPopup('syslogTypesDlg');
	};

	$scope.syslogTypesTableConfig = {
		dataURL: function () {
			return '/syslogTypes';
		},
		fields: [{ label: 'Name', path: 'name', template: '<span>{{item}}</span>' },
		],
		parseData: function (dataItems) {
			let result = [];
			dataItems.forEach(function (dataItem) {
				result.push(dataItem.name);
			});
			return result;
		},
		actions: [],
		selectedItems: [],
		selectIdentifier: 'item',
	};

	$scope.addSyslogTypes = function () {
		$scope.syslog.syslogTypes = [];
		$scope.syslogTypesTableConfig.selectedItems.forEach(function (tag) {
			$scope.syslog.syslogTypes.push(tag);
		});
		$scope.$root.closePopup('syslogTypesDlg');
	};

	function loadProviderFromAuthMethod() {
					store.fetch({
									path: '/getSsoProvider',
									queryParams: { accountId: $state.params.accountId },
									success: function (data) {
													$scope.provider = data;
									}
					})
	};

    function loadExternalSystems() {
        store.fetch({
            path: '/getExternalSystems',
            queryParams: { accountId: $state.params.accountId },
            success: function (data) {
                $scope.externalSystem = data;
                if ($scope.externalSystem.ssoConfiguration && $scope.externalSystem.ssoConfiguration.oktaConfiguration)
                    $scope.oktaConfiguration = $scope.externalSystem.ssoConfiguration.oktaConfiguration;
																				$scope.oktaConfigurationOrig = angular.copy($scope.oktaConfiguration);
                if($scope.externalSystem.scimProvisioning.length > 0){
																				$scope.scimProvisioning = $scope.externalSystem.scimProvisioning[0];
																}
                $scope.externalSystemOrig = angular.copy($scope.externalSystem);
                $scope.showOktaEditPW = false;
            },
        });
    }


	 $scope.certificatesConfig = {
		 dataURL: function() {
			 return null;
		 },
		 parseData: function() {
			 return $scope.account.certificates;
		 },
		 fields: [
			 {
				 label: 'Name',
				 path: 'systemName',
				 template: '<span><input type="text" class="form-control" ng-model="item.systemName"></span>'
			 },
			 {
				 label: 'Subject Name',
				 path: 'subject'
			 },
			 {
				 label: 'Issuer',
				 path: 'issuer'
			 },
			 {
				 label: 'Creation Date',
				 template: '<span>{{item.certCreationTimeMilliseconds | date : "medium"}}</span>'
			 },
			 {
				 label: 'Expiration Date',
				 template: '<span>{{item.certExpirationTimeMilliseconds | date : "medium"}}</span>'
			 },
			 {
				 template:
					 '<span ng-if="!item.isNewItem" ng-click="tableConfig.showDetails(item)" data-title="Show details" class="cato-tooltip certificates-more-details">' +
					 	'<span class="glyphicon glyphicon-eye-open"></span>' +
					 '</span>' +
					 '<span ng-if="item.isNewItem" class="cert-file-input">' +
					 	'<button class="btn cato-btn" ng-click="tableConfig.selectFile(\'CertificatePem\', item)">Upload file</button>' +
					 '</span>' +
					 '<span ng-if="item.isExpired" class="cato-tooltip certificate-expired" ' +
					 	'data-title="This certificate has expired and is no longer valid to sign certificates. Device certificates that were signed before the expiration date of the certificate are still valid.">' +
					 '<span class="glyphicon glyphicon-exclamation-sign"></span>' +
					 '</span>' +
					 '<span ng-if="item.isAboutToExpire" class="cato-tooltip certificate-about-to-expire" data-title="This certificate is about to expire">' +
					 	'<span class="glyphicon glyphicon-exclamation-sign"></span>' +
				     '</span>'
			 }
		 ],
		 titleSearch: false,
		 noSearch: true,
		 noSort: true,
		 fixedLayout: true,
		 actions: [],
		 addAction: function() {
			 let newItem = {
				 systemName: "",
				 isNewItem: true
			 };
			 $scope.account.certificates.push(newItem);
			 $scope.orig.certificates.push(newItem); // we don't want to enable the SAVE button
			 $scope.certTableDataModified = new Date().getTime();
		 },
		 specialActions : [
			 {
				 icon: 'trash',
				 tooltip: 'Delete',
				 func: function(selectedItems, config) {
					 const deletedIds = selectedItems.map(item => item.id);
					 $scope.account.certificates = $scope.account.certificates.filter(item => deletedIds.indexOf(item.id) < 0);
					 $scope.certTableDataModified = new Date().getTime();
				 }
			 }
		 ],
		 selectedItems:[],
		 selectFile: function(fileType, item) {
			 if (!item.systemName || item.systemName === '') {
				 $scope.$root.showNotification("error", "Please enter a name for the certificate", "Certificate", true, false);
				 return;
			 }

			 const input = $(document.createElement('input'));
			 input.attr("type", "file");
			 input.trigger('click');

			 input.change(function(event) {
				 const file = event.target.files[0];

				 const formData = new FormData();

				 formData.append('accountId', $state.params.accountId);
				 formData.append('file', file);
				 formData.append('userFileName', item.systemName);

				 store.uploadFile({
					 url: "/certificates/upload",
					 method: "POST",
					 file: formData,
					 contentType: 'multipart/form-data',
					 success: function (serverResponse) {
						 if (serverResponse.status && serverResponse.status === "ERROR") {
						 	$scope.$root.showNotification("error", serverResponse.notifications[0].message, "Certificate", true, false);
						 	return;
						 }
						 const data = serverResponse.data.certificates;
						 $scope.$root.showNotification("success", "Certificate uploaded successfully", "Certificate", false, false);
						 $scope.account.certificates = $scope.account.certificates.filter(certificate => certificate.isNewItem !== true);
						 $scope.account.certificates.push(angular.copy(data[data.length - 1]));

						 // we don't want to enable the SAVE button
						 $scope.orig.certificates = $scope.orig.certificates.filter(certificate => certificate.isNewItem !== true);
						 $scope.orig.certificates.push(angular.copy(data[data.length - 1]));

						 $scope.certTableDataModified = new Date().getTime();
					 }
				 });
			 });
		 },
		 showDetails: function (item) {
			 store.fetch({
				 method: 'GET',
				 url: '/certificates/getInfo',
				 queryParams: {
					 accountId: $state.params.accountId,
					 certId: item.id
				 },
				 success: function (serverResponse) {
				 	if (serverResponse.status && serverResponse.status === "OK") {
						$scope.certificateDetails = [];
						for (let prop in serverResponse.data.certInfo) {
							let value = serverResponse.data.certInfo[prop];
							if (prop.indexOf("Not Valid") >= 0) {
								value = $filter('date')(value, "medium")
							}
							$scope.certificateDetails.push({
								key: prop,
								value: value
							});
						}
						$scope.certDetailsDataModified = new Date().getTime();
						$rootScope.openPopup('certificateDetails');
					}
				 }
			 });
		 }
	 };

    $scope.certificateDetailsConfig = {
		dataURL: function() {
			return null;
		},
		parseData: function() {
			return $scope.certificateDetails;
		},
		fields: [
			{
				path: 'key',
			},
			{
				path: 'value'
			},
		],
		titleSearch: false,
		noSearch: true,
		noSort: true,
		fixedLayout: true,
		hideHead: true
	}

	$scope.saveLDAP = function () {
        $scope.$broadcast('saveExternalSystem');
        $scope.loading = false;
	};

	$scope.saveWmiSource = function (callBack) {
		var path;
		var params;

		$scope.account.wmiDomainControllers = $scope.wmiSourceConfig.items;
		$scope.account.newSaveMethod = true;
		if ($scope.account.itemsToDelete && $scope.account.itemsToDelete.wmiDomainControllers) {
            store.remove({
                type: 'wmiDomainController',
                items: $scope.account.itemsToDelete.wmiDomainControllers.map(function (dc) { return dc.id}),
                success: function(data) {
                    $scope.$root.handleServerResponse(data, 'domain', 'Domain saved successfully');
                    $scope.wmicontrollersdatamodified = new Date().getTime();
                    $scope.loading = false;
                    if (callBack) {
                        callBack();
                    }
                }
            })
        };

        $scope.account.wmiDomainControllers.forEach(function (modifiedDc)
        {
            if ($scope.wmiSourceConfig.origDomainItems.map(function(obj) {return angular.toJson(obj);}).indexOf(angular.toJson(modifiedDc)) < 0) {
                modifiedDc.newSaveMethod = true;
                store.save({
                    path: '/edit',
                    data: modifiedDc,
                    dataObj: 'json',
                    queryParams: {'wmidomaincontrollerId':modifiedDc.id,'save':true},
                    success: function (data) {
                        $scope.loading = false;
                        $scope.$root.handleServerResponse(data, 'domain', 'Domain Controller saved successfully');
                        if (data.status != 'ERROR') {
                            $scope.wmicontrollersdatamodified = new Date().getTime();
                            if (callBack) {
                                callBack();
                            }
                        }
                    },
                });
            }
        }
        );
	};

	$scope.addDomainControllers = function () {
		if ($scope.currentCategory.name === 'Directory Services') {
            // remove de-selected items
			for (var i = 0; i < $scope.controllersConfig.items.length; i++) {
				if ($scope.controllersConfig.items[i].subnet) {
					if ($scope.subnetsConfig.selectedItems.indexOf($scope.controllersConfig.items[i].subnet) === -1) {
						if (!$scope.domain.itemsToDelete) {
							$scope.domain.itemsToDelete = {};
							($scope.domain.itemsToDelete.domainControllers = $scope.domain.itemsToDelete.domainControllers || []).push($scope.controllersConfig.items[i]);
							$scope.controllersConfig.items.splice(i, 1);
						}
					}
				}
			}
            // add newly selected items
			$scope.subnetsConfig.selectedItems.forEach(function (subnet) {
				if (!_.find($scope.controllersConfig.items, { subnet: subnet })) { $scope.controllersConfig.items.push({ id: GeneralUtilsService.getRandomId(), subnet: subnet, siteName: subnet.siteName }); }
			});
			if ($scope.newDomainController.host) {
				$scope.controllersConfig.items.push({ id: GeneralUtilsService.getRandomId(), host: $scope.newDomainController.host, port: $scope.newDomainController.port });
			}
		}
		$scope.$root.closePopup('addDomainControllers');
	};

	 $scope.addDomainControllersForDomain = function () {
                // remove de-selected items
                for (var i = 0; i < $scope.controllersConfig.items.length; i++) {
                    if ($scope.controllersConfig.items[i].subnet) {
                        if ($scope.subnetsConfig.selectedItems.indexOf($scope.controllersConfig.items[i].subnet) === -1) {
                            if (!$scope.domain.itemsToDelete) {
                                $scope.domain.itemsToDelete = {};
                                ($scope.domain.itemsToDelete.domainControllers = $scope.domain.itemsToDelete.domainControllers || []).push($scope.controllersConfig.items[i]);
                                $scope.controllersConfig.items.splice(i, 1);
                            }
                        }
                    }
                }
                // add newly selected items
                $scope.subnetsConfig.selectedItems.forEach(function (subnet) {
                    if (!_.find($scope.controllersConfig.items, { subnet: subnet })) { $scope.controllersConfig.items.push({ id: GeneralUtilsService.getRandomId(), subnet: subnet, siteName: subnet.siteName }); }
                });
                if ($scope.newDomainController.host) {
                    $scope.domain.domainControllers.push({ id: GeneralUtilsService.getRandomId(), host: $scope.newDomainController.host, port: $scope.newDomainController.port });
                }
            $scope.$root.closePopup('addDomainControllersForDomain');
        };

    $scope.enableOktaPwChanage = function () {
        $scope.showOktaEditPW = true;
    }



	$scope.selectDestinations = function (item, field, id) {
		$scope.showDest = 'service';
		$scope.appsConfig.selectedItems = [];
		$scope.categoriesConfig.selectedItems = [];
		$scope.urlCategoriesConfig.selectedItems = [];
		$scope.servicesConfig.selectedItems = [];
		$scope.customAppsConfig.selectedItems = [];
		$scope.customCategoriesConfig.selectedItems = [];
		$scope.allowAnyDest = false;
		$scope.tlsInspection.destinations.forEach(function (entity) {
			if (entity.type === 'App') {
				if (entity.id === 'Any') {

				} else {
					$scope.appsConfig.selectedItems.push(entity);
				}
			} else if (entity.type === 'AppCategory') {
				$scope.categoriesConfig.selectedItems.push(entity);
			} else if (entity.type === 'CustomApplication') {
				$scope.customAppsConfig.selectedItems.push(entity);
			} else if (entity.type === 'CustomCategory') {
				$scope.customCategoriesConfig.selectedItems.push(entity);
			} else if (entity.type === 'URLFilter') {
				$scope.urlCategoriesConfig.selectedItems.push(entity);
			} else if (entity.type === 'Service') {
				$scope.servicesConfig.selectedItems.push(entity);
			} else {
				$scope.subnetsConfig.selectedItems.push({ name: entity.name, type: 'TLD', id: entity.id });
			}
		});
		$scope.newIPApplication.ips = $scope.tlsInspection.destinations.filter(function (dest) { return dest.type === 'IP'; }).map(function (dest) { return dest.name; }).join();
		$scope.freeText = $scope.tlsInspection.destinations.filter(function (dest) { return dest.type === 'TLD'; }).map(function (dest) { return dest.name; }).join();
		$scope.fqdnFreeText = $scope.tlsInspection.destinations.filter(function (dest) { return dest.type === 'FQDN'; }).map(function (dest) { return dest.name; }).join();
		$scope.destContext = 'TLS_INSPECTION';
		$scope.$root.openPopup('destinationDlg');
	};

	$scope.selectEntities = function (item, field, id) {
		$scope.showItem = 'group';
		var list = (item.indexOf('inspectionEntitiesExceptOf') !== -1) ? $scope.tlsInspection.entitiesNotToInspect : $scope.tlsInspection.entities;
		$scope.allowAnyEntity = false;
		$scope.groupsConfig.selectedItems = [];
		$scope.sitesConfig.selectedItems = [];
		$scope.accessloginsConfig.selectedItems = [];
		$scope.subnetsConfig.selectedItems = [];
		list.forEach(function (entity) {
			if (entity.id !== -1 && entity.name !== 'Any') {
				if (entity.type === 'GROUP') {
					$scope.groupsConfig.selectedItems.push(entity);
				} else if (entity.type === 'SITE') {
					$scope.sitesConfig.selectedItems.push(entity);
				} else if (entity.type === 'ACCESSLOGIN') {
					$scope.accessloginsConfig.selectedItems.push(entity);
				} else if (entity.type === 'INTERFACEIPRANGE' || entity.type === 'SUBNET') {
					$scope.ipRangesConfig.selectedItems.push(entity);
				}
				else if(entity.type === 'FLOATINGIPSUBNET'){
				    $scope.floatingIpsConfig.selectedItems.push(entity);
				} else if(entity.type === 'DIRECTORYSERVICEUSER'){
				    $scope.dsUsersConfig.selectedItems.push(entity);
				} else {
					//entity.type = 'HOSTSUBNET'; // Fill type on existing configuration
					$scope.subnetsConfig.selectedItems.push(entity);
				}
			}
		});
		$scope.field = (item.indexOf('inspectionEntitiesExceptOf') !== -1) ? 'non-entities' : 'entities';
		$scope.$root.openPopup('addItem');
		$scope.currentAction = this.ruleAction;
	};

	$scope.addItems = function () {
		var ok = true;
        var myList;

        if ($scope.currentCategory.name === 'TLS Inspection') {
		     myList = $scope.field === 'non-entities' ? $scope.tlsInspection.entitiesNotToInspect : $scope.tlsInspection.entities;
		}

		myList.length = 0;

		if ($scope.allowAnyEntity) {
			myList.push({ id: -1, display_name: 'Any', name: 'Any' });
		}		else {
            // Sites
			$scope.sitesConfig.selectedItems.forEach(function (site) {
				if (myList.indexOf(site) < 0) {
					site.type = 'SITE';
					myList.push(site);
				}
			});

            // Groups
			$scope.groupsConfig.selectedItems.forEach(function (group) {
				if (myList.indexOf(group) < 0) {
				    if (group.importType === 'SYSTEM')
				        group.type = 'SYSTEMGROUP';
				    else
					    group.type = 'GROUP';
					myList.push(group);
				}
			});

            // Hosts
			$scope.subnetsConfig.selectedItems.forEach(function (host) {
				if (myList.indexOf(host) < 0) {
					host.type = 'HOSTSUBNET';
					myList.push(host);
				}
			});

            // Users
			$scope.accessloginsConfig.selectedItems.forEach(function (user) {
				if (myList.indexOf(user) < 0) {
					user.type = 'ACCESSLOGIN';
					myList.push(user);
				}
			});

			$scope.ipRangesConfig.selectedItems.forEach(function (ipRange) {
				if (myList.indexOf(ipRange) < 0) {
					//ipRange.type = 'INTERFACEIPRANGE';
					myList.push(ipRange);
				}
			});
			$scope.dsUsersConfig.selectedItems.forEach(function (ipRange) {
				if (myList.indexOf(ipRange) < 0) {
					ipRange.type = 'DIRECTORYSERVICEUSER';
					myList.push(ipRange);
				}
			});
			$scope.floatingIpsConfig.selectedItems.forEach(function (floatingIp) {
                floatingIp.display_name = floatingIp.display_name ?  floatingIp.display_name : floatingIp.floatingRangeName;
                floatingIp.type = 'FLOATINGIPSUBNET';
                if (myList.indexOf(floatingIp) < 0) {
                    myList.push(floatingIp);
                }
            });
		}
		if (ok) {
			$scope.$root.closePopup('addItem');
		}
	};

	$scope.addDestination = function () {
		var targetList;
		if ($scope.destContext === 'TLS_INSPECTION') { targetList = $scope.tlsInspection.destinations; }

		if ($scope.destContext === 'TRUSTED_ENTITIES') { targetList = $scope.scopeSelection.item.destinations; }

		var ok = true;

		targetList.length = 0;
		if ($scope.allowAnyDest) {
			targetList.push({ display_name: 'Any', id: 'Any', type: 'App' });
		}		else { // Sites
			$scope.appsConfig.selectedItems.forEach(function (site) {
				if (targetList.indexOf(site) < 0) {
					site.type = 'App';
					targetList.push(site);
				}
			});

            // Groups
			$scope.urlCategoriesConfig.selectedItems.forEach(function (group) {
				if (targetList.indexOf(group) < 0) {
					group.type = 'URLFilter';
					targetList.push(group);
				}
			});

            // Hosts
			$scope.servicesConfig.selectedItems.forEach(function (host) {
				if (targetList.indexOf(host) < 0) {
					host.type = 'Service';
					targetList.push(host);
				}
			});

			// custom apps
			$scope.customAppsConfig.selectedItems.forEach(function (app) {
				if (targetList.indexOf(app) < 0) {
					app.type = 'CustomApp';
					if (app.definitions) {
						delete app.definitions;
					}
					targetList.push(app);
				}
			});

			// custom categories
			$scope.customCategoriesConfig.selectedItems.forEach(function (app) {
				if (targetList.indexOf(app) < 0) {
					app.type = 'CustomCategory';
					app.display_name = app.name;
					targetList.push(app);
				}
			});

            // Users
			$scope.categoriesConfig.selectedItems.forEach(function (user) {
				if (targetList.indexOf(user) < 0) {
					user.type = 'AppCategory';
					targetList.push(user);
				}
			});
			if ($scope.newIPApplication.ips) {
				var ips = $scope.newIPApplication.ips.split(',');
				ips.forEach(function (ipStr) {
					if (ipStr.indexOf(':') < 0) {
						ok = false;
						alert('Incorrect format for custom service, please enter <name>:<ip address> (sampleservice:10.10.10.1,newservice:20.20.20.8)');
					}
					if (ok) {
						var ipSplitted = ipStr.split(':');
						targetList.push({ id: ipSplitted[0].trim() + ':' + ipSplitted[1].trim(), name: ipSplitted[0].trim() + ':' + ipSplitted[1].trim(), type: 'IP' });
					}
				});
			}
			$scope.freeText.split(',').forEach(function (tld) {
				if (tld.trim().length > 0) { targetList.push({ id: tld.trim(), name: tld.trim(), type: 'TLD' }); }
			});
			$scope.fqdnFreeText.split(',').forEach(function (fqdn) {
				if (fqdn.trim().length > 0) { targetList.push({ id: fqdn.trim(), name: fqdn.trim(), type: 'FQDN' }); }
			});
		}

		if (ok) {
			$scope.$root.closePopup('destinationDlg');
		}
	};

	$scope.fetchAllocatedIps = function() {
		if (!LocationService.hasLocationForAccount($state.params.accountId)) {
			$timeout(function() {
            	$scope.fetchAllocatedIps();
            }, 50, false);
            return;
		}

        LocationService.getAllocatedIpsWithLocations($state.params.accountId, function(items) {
            $scope.allocatedIps = angular.copy(items);
            initPortForwardingRules();
        });
	};

	$scope.groupsConfig = {
		fixedLayout: true,
		titleSearch: true,
		dataURL: function () {
			return '/groups?accountId=' + $state.params.accountId;
		},
		fields: [{label: 'Name', path: 'name', template: '<span>{{item.prefix}}{{item.name}}</span>'},
			{label: 'Description', path: 'description', template: '<span>{{item.description}}</span>'},
		],
		type: 'Group',
		actions: [],
		selectedItems: [],
		pageSize: DEFAULT_PAGE_SIZE,
	};

	$scope.sitesConfig = {
		titleSearch: true,
		dataURL: function () {
			var accountId = $scope.currentAccountId || $state.params.accountId;
			return '/sites?accountId=' + accountId;
		},
		showTable: false,
		fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
            { label: 'Address', path: 'address', template: '<span>{{item.address}}</span>' },
		],
		type: 'Site',
		actions: [],
		selectedItems: [],
		pageSize: DEFAULT_PAGE_SIZE,
	};

	$scope.accessloginsConfig = {
		titleSearch: true,
		statusNames: { DISABLED: 'Disabled', ACTIVE: 'Configured', SUSPENDED: 'Suspended', NEW: 'New', PENDING_USER_CONFIGURATION: 'Invitation Sent' },
		loginNameById: {},
		dataURL: function () {
			var accountId = $scope.currentAccountId || $state.params.accountId;
			return '/logins?accountId=' + accountId;
		},
		fields: [{ label: 'Name', path: 'name', template: '<span>{{item.name}}<span>' },
            { label: 'E-mail', path: 'email' },
		],
		type: 'AccessLogin',
		actions: [],
		selectedItems: [],
		pageSize: DEFAULT_PAGE_SIZE,
	};

	$scope.ipRangesConfig = {
		titleSearch: 'Range',
		searchField: 'display_name',
		fixedLayout: true,
		dataURL: function () {
			return '/getNetworks?isRequestFromOFE=1&accountId=' + $state.params.accountId;
		},
		showTable: false,
		fields: [
			{label: 'Name', path: 'name', template: '<span>{{item.name}}</span>'},
            { label: 'Site', path: 'siteName', template: '<span>{{item.siteName}}</span>' },
            { label: 'Interface', path: 'interfaceName', template: '<span>{{item.interfaceName}}</span>' },
            { label: 'Type', path: 'type', template: '<span>{{item.subnetType | capitalize}}</span>' },
            { label: 'Range', path: 'subnet', template: '<span>{{item.subnet}}</span>' },
		],
		type: 'IPRange',
		actions: [],
		selectedItems: [],
		pageSize: DEFAULT_PAGE_SIZE,
	};

	$scope.floatingIpsConfig =  {
        titleSearch: true,
        fixedLayout: true,
        accountId: $state.params.accountId,
        method: 'GET',
        dataURL : function(){
            return "/getFloatingIps?accountId=" + $state.params.accountId;
        },
        fields : [
            {label: 'Name', path: 'floatingRangeName', template: '<span>{{item.floatingRangeName}}</span>'},
            {label:"IP Range","path":"subnet",template:"<span>{{item.subnet}}</span>"}],
        processData: function(items){
        },
        type : "floatingips",
        actions: [],
        selectedItems:[],
        pageSize:DEFAULT_PAGE_SIZE,
        clientSidePaging: true,
        clientSideSearch: true,
        clientSideSort: true
    };

	  //receive deleted items and add them to ItemsToDelete
        $scope.deleteItems = function(items, propertyName){
           GeneralUtilsService.addItemsToDelete($scope.account, items, propertyName);
        };

	function initLocationsConfig(data){
		$scope.locationsConfig = {
			dataURL: function () {
				return null;
			},
			method:'GET',
			showTable: false,
			actions: [],
			pageSize: DEFAULT_PAGE_SIZE,
			titleSearch: true,
			fixedLayout: true,
			fields: [{ label: 'Name', template: '<span>{{item.name | capitalize}}</span>', path: 'name' }],
			type: 'Location',
			selectedItems: [],
			parseData: function () {
				data.forEach(function (item) {
					item.id = item.name;
				});
				return data;
			},
    	   	clientSidePaging: true,
    	   	clientSideSearch: true,
    	   	clientSideSort: true
		};
	}

	$scope.urlCategoriesConfig = {
        dataURL: function () {
            return '/urlPlainUrlCategories';
        },
        showTable: false,
        actions: [],
        pageSize: DEFAULT_PAGE_SIZE,
        titleSearch: true,
        fixedLayout: true,
        fields: [{ label: 'Name', template: '<span>{{item.name | capitalize}}</span>', path: 'name' }],
        type: 'UrlCategory',
        selectedItems: [],
        processData: function (items) {
            items.forEach(function (item) {
                item.id = item.category;
            });
        },
    };

	$scope.customCategoriesConfig = {
		titleSearch: true,
		dataURL : function () {
			return "/getCustomCategories?accountId=" + $state.params.accountId;
		},
		actions: [],
		pageSize:DEFAULT_PAGE_SIZE,
		sortField:"name",
		searchField:"name",
		fields : [{"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},{"label":"Description","path":"description","template":"<span>{{item.description}}</span>"}],
		type : "CustomCategory",
		parseData: function (data) {
			var items = [];
			for (var key in data) {
				var item = data[key];
				item.display_name = item.name;
				item.tyep = 'CustomCategory';
				items.push(item);
			}
			return items;
		},
		selectedItems:[]
	};

    //chages syslog token used to generate syslog file prefix in S3
    $scope.changeAccountSyslogToken = function() {
    store.save({
    			method: 'POST',
    			queryParams: { accountId: $state.params.accountId },
    			path: '/changeSyslogToken',
    			success: function (data) {
    				$scope.$root.closePopup('changeSyslogTokenDlg');
    				$rootScope.globalNotification = { type: 'success', message: 'Syslog token was changed successfully'};
                    $rootScope.$emit('$saveSuccess');
    			},
    		});
    }

	 $scope.userProvisioningMethodOptions = [
		 {
			 value: 'INV_EMAIL',
			 key: 'Invitation Email'
		 },
		 {
		     value: 'REG_CODE',
		     key: 'Registration Code'
		 }
	 ];

    //adds the deleted general properties from the general properties component to account deleted items list
    $scope.addDeletedGeneralProperties = function (properties) {
         if (properties.length > 0) {
                if (!$scope.account.itemsToDelete) {
                    $scope.account.itemsToDelete = {};
                }
          $scope.account.itemsToDelete.generalProperties = ($scope.account.itemsToDelete.generalProperties && $scope.account.itemsToDelete.generalProperties.length > 0) ?
                                                                              properties.concat($scope.account.itemsToDelete.generalProperties) : properties;
        }
    }

	function setMaintenanceWindowTimeFrames() {
		$scope.days = [{caption: 'Monday',id: 1},{caption: 'Tuesday',id: 2,},{caption: 'Wednesday',id: 3},{caption: 'Thursday',id: 4},
			{caption: 'Friday',id: 5},{caption: 'Saturday',id: 6},{caption: 'Sunday',id: 7}];
		$scope.timeFrames = [];

		for (var i = 0; i < 23; i++) {
			$scope.timeFrames.push({
				caption: (i + ':00') + ' - ' + ((i + 2) + ':00'),
				id: i,
			});
		}

		$scope.timeFrames.push({
			caption: ('23:00') + ' - ' + ('1:00'),
			id: 23,
		});
	}

	function init() {
	    load();

		store.fetch({
			method: 'POST',
			queryParams: { accountId: $state.params.accountId },
			path: '/getAllSites',
			success: function (data) {
				$scope.sites = data.items;
			},
		});

		store.fetch({
			path: '/getAzureProperties',
			success: function (data) {
				$scope.clientId = data.clientId;
				$scope.redirect_uri = data.redirect_uri;
				$scope.roleIsViewer = UserContextService.isDisableGUI();
				$scope.href = "https://login.windows.net/common/oauth2/authorize?response_type=code&client_id=" + $scope.clientId + "&resource=https%3A%2F%2Fgraph.windows.net&redirect_uri=" + $scope.redirect_uri + "&state=registration|" + $state.params.accountId + "&prompt=admin_consent"
			},
		});
		// Syslog
		store.fetch({
			path: '/getSyslog',
			queryParams: { accountId: $state.params.accountId },
			success: function (data) {
				$scope.syslog = data;
				$scope.accountId = $state.params.accountId;
				setChanges('SYSLOG');
			},
		});

		$scope.loadLocations();
		$scope.fetchAllocatedIps();
		$scope.loadSyslogFormats();
		$scope.loadSyslogPullTypes();
		initDataModifiersWatchers();
		setMaintenanceWindowTimeFrames();
	}

	init();

	$scope.$on('$destroy', function(){
		$(".toggle-password").off("click", togglePassword);
		$("#passwordfield").off("keyup", keyUpPasswordField);
	});

	$scope.generateRegCodesForNewUsers = function () {
		const saveBeforeGenerate = $scope.changedToRegCodeUnsaved();
		let confirmationMessage;
		if ($scope.account.registrationCodeConfiguration.sendEmails) {
			confirmationMessage = "Are you sure that you want to send emails with Registration Codes to all new users?\n";
		} else {
			confirmationMessage = "Are you sure that you want to generate Registration Codes for all new users?\n";
		}

		if (saveBeforeGenerate) {
			confirmationMessage += "Note: Generating codes for new users saves the settings for the User Provisioning window.";
		}

		$scope.$root.confirm(confirmationMessage, function() {
            if (saveBeforeGenerate) {
                $scope.saveChanges();
            }
            store.action({
                method: 'POST',
                path: '/generateRegCodesForNewUsers?accountId=' + $state.params.accountId,
                success: function(data) {
                    if (!saveBeforeGenerate) {
                        $scope.$root.showNotification("success", "Generated Registration Codes for all new users", "Registration Code", false, false);
                    }
                }
            });
        })
	};

	$scope.downloadRegCodes = function () {
	    if ($scope.changedToRegCodeUnsaved()) {
			$scope.$root.confirm("Downloading the Registration Codes also saves the User Provisioning settings. Do you want to continue?", function() {
				$scope.saveChanges();
				downloadRegCodesCSV();
			});
		} else {
			downloadRegCodesCSV();
		}
    };

	function downloadRegCodesCSV() {
		// sending timestamp to prevent server cached response
		fetch('downloadRegCodes?accountId=' + $state.params.accountId + "&timestamp=" + Date.now().toString())
			.then(resp => {
				if (resp.status !== 200) {
					throw 'error';
				}

				return resp.blob();
			})
			.then(blob => {
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.style.display = 'none';
				a.href = url;
				a.download = "RegistrationCodes_" + moment().format('MMMM-Do-YYYY-h-mm-ss') + ".csv";
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
			})
			.catch(() => {
				$scope.$root.showNotification("error", "Registration Code download failed", "Registration Code download failed", true, false);
			});
	}


	 $scope.subnetsConfig = {
        titleSearch: true,
        dataURL: function () {
            return '/subnets?accountId=' + $state.params.accountId;
        },
        showTable: false,
        fields: [
            { label: 'Name', path: 'name', template: '<span>{{item.name}}</span>' },
            { label: 'Site', name: 'siteName', template: '<span>{{item.siteName}}</span>' },
            { label: 'Network', path: 'interfaceName', template: "<span>{{item.interfaceName}} <span ng-if='item.range'> \\ {{item.range}}</span></span>" },
            { label: 'IP', path: 'subnet', template: '<span>{{item.translatedSubnet}}</span>' }
        ],
        type: 'Subnet',
        actions: [],
        selectedItems: [],
        pageSize: DEFAULT_PAGE_SIZE,
    };

    $scope.ExpirationTimeUnitOptions = [
        {
            value: 'HOURS',
            key: 'Hours'
        },
        {
            value: 'DAYS',
            key: 'Days'
        }
    ];

	 $scope.ssoSettingsUnsaved = function() {
		 return $scope.externalSystemOrig.ssoConfiguration
			 && !angular.equals($scope.externalSystemOrig.ssoConfiguration.provider, $scope.externalSystem.ssoConfiguration.provider)
	 }

	 $scope.setAccountDhcpRelayGroup = (accountDhcpRelayGroup, dhcpRelayGroups) => {
	 	if (accountDhcpRelayGroup && dhcpRelayGroups){
			dhcpRelayGroups.forEach(drg => drg.accountSelectedGroup = drg.id === accountDhcpRelayGroup.id);
			$scope.hasChanges.dhcpRelayGroups = true;
		}
	 }

	 $scope.onDhcpRelayEnabledCheck = (dhcpConfig) => {
	 	if (dhcpConfig?.dhcpRelayEnabled && !dhcpConfig.accountSelectedDhcpGroup && dhcpConfig.dhcpRelayGroups?.length > 0){
			dhcpConfig.accountSelectedDhcpGroup = dhcpConfig.dhcpRelayGroups.filter(drg => drg.accountSelectedGroup)[0];
		}
	 }
}
